// date 
import moment from 'moment';
// Excel 
import ExcelJS from 'exceljs';
// image
import { AirportLogos } from '_atoms';
import PRMLogo from "../assets/images/PRM-Logo-PNG/PRM-Assist-Logo-Col.png";
import ReactDOMServer from "react-dom/server";

import * as TaskColors from "../scenes/portal/timeline/utils/colors";
import { ASSISTANCE_PRIORITY, PRMCodes } from './constants';
import { Colors } from '_styles';

export const SaudiDomesticAirports = [
  "JED", "RUH", "DMM", "MED", "AHB", "AQI", "ABT",
  "EJH", "SHW", "BHH", "WAE", "DWD", "EAM", "GIZ",
  "HAS", "AJF", "TIF", "ULH", "TUI", "RAE", "RAH",
  "URY", "TUU", "RSI", "NUM", "HOF", "ELQ", "YNB",
  "QJB",
];

export const isFullArray = (arr) => Array.isArray(arr) && arr.length > 0;
export const isObjectEmpty = (obj) => !obj || Object.keys(obj).length === 0;


export function getCurrentHalfHourSlot(thirtyMinLayout = true) {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");

  if (!thirtyMinLayout) {
    // Full hour slot: return 15:00-16:00 style
    const start = `${hours}:00`;
    const end = `${String(now.getHours() + 1).padStart(2, "0")}:00`;
    return `${start}-${end}`;
  }

  // 30-minute slot
  const minutes = now.getMinutes() < 30 ? "00" : "30";
  const start = `${hours}:${minutes}`;
  const endMinutes = minutes === "00" ? "30" : "00";
  const endHour = minutes === "00" ? hours : String(now.getHours() + 1).padStart(2, "0");
  const end = `${endHour}:${endMinutes}`;

  return `${start}-${end}`;
}


// set the card top border color by the task status
export const handleCardTopColor = (job, flightType) => {

  // check if alt pickup task
  if (job?.isALTPickUp) { return TaskColors.ALTPickUps }

  // check if break task
  if (job?.isBreakTask) return TaskColors.breakTasks

  // check if transit booking
  if (job?.isTransitBooking == true
    && job?.pending !== true
    && job?.active !== true
    && job?.cancelled !== true
    && job?.completed !== true) {
    return TaskColors.transitBookings
  }

  // check if pending
  if (job?.pending == true) {
    return TaskColors.pendingTasks
  };

  // check if active
  if (job?.active == true) return TaskColors.activeTasks;

  // check if cancelled
  if (job.cancelled == true) return TaskColors.rejectedTasks;

  // check if completed
  if (job?.completed == true) return TaskColors.completedTasks;

  // check if stopped
  if (job?.stopped == true) return TaskColors.rejectedTasks;

  // check if acknowledged
  if (job?.acknowledged == true || job?.isAtLocation == true) return TaskColors.acknowledgedTasks;

  // check if grouped booking
  if (job?.combinedBooking) {
    return TaskColors.combinedBooking;
  }

  if (job?.combinedRampBooking) {
    return TaskColors.combinedRampBooking;
  }

  // check for arrival
  if (flightType == "arrival") {
    return TaskColors.arrivals
  }

  // check for departure
  if (flightType == "departure") {
    return TaskColors.departures
  }

  return "lightgrey";
};

export const getCardClickedColor = (job, flightType) => {
  if (job?.isALTPickUp) return '#f5b5d8';
  if (flightType === "departure") return '#C7E2FD'
  else if (flightType === "arrival") return '#BDF4B6'
  else return 'lightgrey';
}


export function minutesSince(timeString) {
  const [hours, minutes] = timeString.split(':').map(Number); // Parse the input time
  const inputMinutes = hours * 60 + minutes; // Convert input time to total minutes since midnight

  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes(); // Convert current time to total minutes since midnight

  return currentMinutes - inputMinutes; // Calculate the difference in minutes
}

export function calculateMinuteDifference(time1, time2) {
  // Helper function to convert hh:mm to total minutes
  const timeToMinutes = (time) => {
    if (!time || typeof time !== "string" || !time.includes(":")) return 0;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  };

  // Convert both times to total minutes
  const minutes1 = timeToMinutes(time1);
  const minutes2 = timeToMinutes(time2);

  // Calculate the absolute difference
  const difference = Math.abs(minutes2 - minutes1);

  return difference;
}


export const getTimeString = (dateString) => {
  const dateObj = new Date(dateString);
  const options = { hour: "2-digit", minute: "2-digit", hour12: false };
  const formattedTime = dateObj.toLocaleString("en-US", options);
  return formattedTime;
};

export const truncateName = (name, maxLength = 10) => {
  if (name?.length > maxLength) {
    return name?.substring(0, maxLength) + '...';
  }
  return name;
};


export const getDurationInMinutes = (firstDate, secondDate) => {
  let time1 = new Date(firstDate);
  let time2 = new Date(secondDate);
  const timeDifference = Math.abs(time2.getTime() - time1.getTime());
  const minutesDifference = Math.ceil(timeDifference / (1000 * 60));
  return `${minutesDifference} minutes`;
};

export const getSeatNumber = (obj) => {

  let assistanceArr = [];
  const seatNumberRegex = RegExp(/\s\d{1,3}[A-Z]/gm);
  if (obj?.seatNumber) return obj.seatNumber;
  if (obj?.flightInformation?.seatNumber)
    return obj?.flightInformation?.seatNumber;

  if (Array.isFullArray(obj?.assistance)) {
    assistanceArr = obj?.assistance?.map((str) => str?.match(seatNumberRegex));

  }
  if (Array.isFullArray(obj?.passengerInformation?.assistance)) {
    assistanceArr = obj?.passengerInformation?.assistance?.map((str) =>
      str?.match(seatNumberRegex)
    );

  }
  if (!assistanceArr) return "";
  let seatNumberMatches = assistanceArr.filter((x) => {
    return x;
  });
  return seatNumberMatches?.[0]?.[0] ?? "";
};


// function for matching employee name in timeline with search term
export const searchEmployeeName = (employee, searchValue) => {
  if (employee?.title) {
    // clean the employee name
    let cleanEmployeeName = employee.title.toLowerCase().replace(/\s/g, '');
    let cleanSearchTerm = searchValue.toLowerCase().replace(/\s/g, '');
    // check if the employee name contains the search term
    return cleanEmployeeName.includes(cleanSearchTerm);
  }
}

// function for matching employee ID in timeline with search term
export const searchEmployeeID = (employee, searchValue) => {
  if (employee?.employeeId) {
    // clean the employee id
    let cleanEmployeeId = employee.employeeId.toLowerCase().replace(/\s/g, '');
    let cleanSearchTerm = searchValue.toLowerCase().replace(/\s/g, '');
    // check if the employee name contains the search term
    return cleanEmployeeId.includes(cleanSearchTerm);
  }

}

// functions for bookings search filtering in timeline
// check search term
export const searchBooking = (booking, bookingSearch) => {
  if (booking?.doc?.name || booking?.name) {
    let name = booking?.doc?.name ?? booking?.name ?? "";

    // clean name string
    name = name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    // clean search term
    let searchTerm = bookingSearch.replace(/[^a-zA-Z0-9]/g, '')?.toLowerCase();

    return name.includes(searchTerm);
  }
}

export const searchFlights = (booking, bookingSearch) => {
  if (booking?.doc?.flightConfirmationDetails || booking?.flightConfirmationDetails) {
    let flight = booking.doc
      ? `${booking?.doc?.flightConfirmationDetails?.carrierCode}${booking?.doc?.flightConfirmationDetails?.flightNumber}`
      : `${booking?.flightConfirmationDetails?.carrierCode}${booking?.flightConfirmationDetails?.flightNumber}`;
    if (flight.includes("U2")) {
      flight.replace("U2", "EZY")
    }
    // clean search term
    let searchTerm = bookingSearch.replace(/[a-z]+/g, match => match?.toUpperCase())
    return flight.includes(searchTerm);

  }
  else {
    return false
  }
}



export const getDate = (date) => {
  if (!date) return new Date()
  return moment(new Date(date)).format()?.split("T")[0]
}

export const getDateOneWeekAgo = (currentDate) => {
  // Get the current timestamp
  const currentTimestamp = currentDate.getTime();

  // Calculate the timestamp for 7 days ago (7 * 24 * 60 * 60 * 1000 milliseconds)
  const sevenDaysAgoTimestamp = currentTimestamp - 604800000;

  // Create a new date object from the timestamp for 7 days ago
  const sevenDaysAgo = new Date(sevenDaysAgoTimestamp);

  return sevenDaysAgo;
}

// convert timestamp to local date string
export const convertShiftTimeStamp = (dateTime, dateOptions) => {
  // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  const options = dateOptions ? dateOptions : { hour: "2-digit", minute: "2-digit", hour12: false };
  if (dateTime instanceof Date) {
    return dateTime.toLocaleString("en-US", options);
  }

  const timestamp = dateTime || {};
  const seconds = timestamp.seconds || 0;
  const nanoseconds = timestamp.nanoseconds || 0;

  // Create a JavaScript Date object using the seconds and nanoseconds
  const date = new Date(seconds * 1000 + nanoseconds / 1e6);

  const formattedTime = date.toLocaleString("en-US", options);

  return formattedTime;
};

// convert timestamp to javascript date 
export const convertTimeStampToDate = (dateTime, dateOptions) => {
  // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  const options = dateOptions ? dateOptions : { hour: "2-digit", minute: "2-digit", hour12: false };
  if (dateTime instanceof Date) {
    return dateTime.toLocaleString("en-US", options);
  }

  const timestamp = dateTime || {};
  const seconds = timestamp.seconds || 0;
  const nanoseconds = timestamp.nanoseconds || 0;

  // Create a JavaScript Date object using the seconds and nanoseconds
  const date = new Date(seconds * 1000 + nanoseconds / 1e6);
  return date;
};

export const getTaskCardStatus = (job, fromLocationPanel = false) => {
  let status, borderColor;
  // check if task is actually assigned (has assignedTime or employeeId)
  const isActuallyAssigned = job?.assignedTime || job?.employeeId;

  // unassigned ALT pickup or gate relocation tasks
  if ((job?.isALTPickUp || job?.isGateRelocation) && !isActuallyAssigned) {
    status = "Not Planned";
    borderColor = "gray";
    return { status, borderColor };
  }

  // unassigned regular bookings (not checked-in)
  const isCheckedIn = job?.paxPositionInfo?.activity === "Checked-in" || job?.originalBookingDoc?.paxPositionInfo?.activity === "Checked-in";
  if (!isActuallyAssigned && !job?.completed && !isCheckedIn && fromLocationPanel !== true) {
    status = "";
    borderColor = "gray";
    return { status, borderColor };
  }
  if (!isActuallyAssigned && !job?.completed && !isCheckedIn && fromLocationPanel === true) {
    status = "Assigned";
    borderColor = "gray";
    return { status, borderColor };
  }

  if (
    job?.active == false &&
    job?.completed == false &&
    job?.pending == false &&
    job?.stopped !== true &&
    job?.acknowledged != true &&
    job?.isAtLocation != true &&
    isActuallyAssigned
  ) {
    status = "Assigned";
    borderColor = "lightgray";
  }
  // Check for acknowledged status specifically (but not if already at location)
  if (
    job?.active == false &&
    job?.completed == false &&
    job?.pending == false &&
    job?.stopped !== true &&
    job?.acknowledged == true &&
    job?.isAtLocation != true
  ) {
    status = "Confirmed";
    borderColor = "lightgray";
  }
  // Check for at location status
  else if (
    job?.active == false &&
    job?.completed == false &&
    job?.pending == false &&
    job?.stopped !== true &&
    job?.isAtLocation == true
  ) {
    if (job?.isAtLocation && job?.atLocationBeaconVerified) {
      status = "At Loc";
    }
    else if (job?.isAtLocation && job?.atLocationQrVerified) {
      status = "At Loc";
    }
    else {
      status = "At Loc";
    }
    borderColor = "lightgray";
  }
  if (job?.active == true && job?.completed == false && job?.pending == false) {
    status = "Active";
    borderColor = "orange";
  }
  if (job?.active == false && job?.completed == false && job?.pending == true) {
    status = "Pending";
    borderColor = "#8316f7";
  }
  if (job?.completed) {
    status = "Completed";
    borderColor = "green";
  }
  if (job?.cancelled != undefined && job?.cancelled == true) {
    status = "Cancelled";
    borderColor = "red";
  }
  if (job?.stopped == true &&
    job?.active !== true &&
    job?.completed !== true && job?.pending !== true && job?.cancelled !== true) {
    status = "Stopped";
    borderColor = "red";
  }

  // chek if status is not assigned
  if (status == '') {
    // check pax location
    if (job?.paxPositionInfo?.activity == "Checked-in") {
      status = "Checked-in";
      borderColor = "green";
    } else if (job?.paxPositionInfo?.activity == "assigned") {
      status = "Assigned";
      borderColor = "lightgray";
    }
  }
  if (job?.isALTPickUp && job?.paxPositionInfo?.activity == "Dropped Off") {
    status = "Completed";
  }

  return {
    status,
    borderColor
  }
}


// extract PAX assistance from booking
export const getAssistanceString = (assistanceArray) => {
  if (Array.isFullArray(assistanceArray)) {
    if (assistanceArray.includes("PLACEHOLDER")) return "ANONYMOUS"
    let tempAssistance = [...new Set(assistanceArray?.map(item => item?.match(/\b[A-Z]{4}\b/g)).flat().filter(Boolean))]
    return tempAssistance?.filter((row) => PRMCodes.includes(row.trim())).join(", ");
  } else {
    return "WCHR";
  }
}

// extract PAX assistance from booking
export const getAssistanceArray = (assistanceArray) => {
  if (Array.isFullArray(assistanceArray)) {
    let tempAssistance = [...new Set(assistanceArray?.map(item => item?.match(/\b[A-Z]{4}\b/g)).flat().filter(Boolean))]

    // check if lanyard is included in the assistance
    if (assistanceArray?.includes("lanyard") || assistanceArray?.includes("LANYARD") || assistanceArray?.includes("Lanyard")) {
      tempAssistance.push("LNYD")
    }
    return tempAssistance?.filter((row) => PRMCodes.includes(row.trim()));
  } else {
    return ["WCHR"];
  }
}

// function to process assistance using PRM codes matching logic
export const processAssistance = (assistance) => {
  if (!assistance) { return [''] }
  let result = []
  assistance.forEach((a) => {
    PRMCodes.forEach((code) => {
      if (a && a.includes(code)) {
        result.push(code)
      }
    });
  });
  result = [...new Set(result)] // Remove duplicates
  return result
}


// function to split array items and act like pagination
export const manualPaginate = (displayedContent = [], itemsNum, pageNum) => {

  const totalCount = displayedContent.length;                                   // the provided array length
  const pageCount = Math.ceil(totalCount / itemsNum);                           // number of pagination pages 

  // Ensure the pageNum is within the valid range after changing itemsNum
  if (pageNum > pageCount) {
    pageNum = pageCount;
  }

  const startIndex = totalCount === 0 ? 0 : (pageNum - 1) * itemsNum;                                  // the start index of the page 
  const endIndex = Math.min(startIndex + itemsNum, totalCount);                 // end index of the page 
  const requiredArr = displayedContent.slice(startIndex, endIndex);             // the new resulted array from original array after been splitted into smaller items
  const currentRange = totalCount === 0 ? `0–0 of 0` : `${startIndex + 1}–${endIndex} of ${totalCount}`;        // the range of the current pagination page (ex. 1-5 of 100, 6-10 of 100)

  return {
    pageCount,
    requiredArr,
    totalCount,
    currentRange,
  };
};

export const generatePaginationRang = (totalCount, itemsNum, pageNum) => {
  // the provided array length
  const pageCount = Math.ceil(totalCount / itemsNum);                           // number of pagination pages 

  // Ensure the pageNum is within the valid range after changing itemsNum
  if (pageNum > pageCount) {
    pageNum = pageCount;
  }
  //recently added
  // if (totalCount === 0) itemsNum = 0;


  const startIndex = (pageNum - 1) * itemsNum;

  // the start index of the page 
  const endIndex = Math.min(startIndex + itemsNum, totalCount);                 // end index of the page 

  let currentRange = `${startIndex + 1}–${endIndex} of ${totalCount}`;        // the range of the current pagination page (ex. 1-5 of 100, 6-10 of 100)
  if (totalCount === 0) {
    currentRange = '0-0 of 0'
  }
  return {
    totalCount,
    currentRange,
  };
};

export const getAssistanceFromPassengerList = (passengerList) => {
  let assistanceList = [];

  passengerList.forEach((passenger) => {
    let assistanceArray = getAssistanceArray(passenger?.assistance);
    assistanceList = [...assistanceList, ...assistanceArray];
  });

  const unique = [...new Set(assistanceList)];
  const sorted = unique.sort((a, b) => {
    const ai = ASSISTANCE_PRIORITY?.findIndex(p => a?.includes(p));
    const bi = ASSISTANCE_PRIORITY?.findIndex(p => b?.includes(p));
    const aPriority = ai === -1 ? ASSISTANCE_PRIORITY?.length : ai;
    const bPriority = bi === -1 ? ASSISTANCE_PRIORITY?.length : bi;
    return aPriority - bPriority;
  });

  return sorted?.join(',') ?? 'WCHR';
}

export const priorityAssistance = (assistanceArray) => {
  if (!Array.isFullArray(assistanceArray)) return ["WCHR"];
  const unique = [...new Set(assistanceArray)];
  const sorted = unique.sort((a, b) => {
    const ai = ASSISTANCE_PRIORITY?.findIndex(p => a?.includes(p));
    const bi = ASSISTANCE_PRIORITY?.findIndex(p => b?.includes(p));
    const aPriority = ai === -1 ? ASSISTANCE_PRIORITY?.length : ai;
    const bPriority = bi === -1 ? ASSISTANCE_PRIORITY?.length : bi;
    return aPriority - bPriority;
  });
  return Array.isFullArray(sorted) ? sorted : ["WCHR"];
}

// set the card status color by the task status
export const getJobStatusColor = (job) => {
  const isRejectedArrJourney = job?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalJourney");
  const isRejectedDepJourney = job?.paxRejection?.find((paxRejection) => paxRejection?.type === "preBoardJourney");
  const isRejectedArrPax = job?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalPax");
  const isRejectedDepPax = job?.paxRejection?.find((paxRejection) => paxRejection?.type === "departurePax");
  const isActuallyAssigned = job?.assignedTime || job?.employeeId;

  // unassigned ALT pickup or gate relocation tasks should be gray
  if ((job?.isALTPickUp || job?.isGateRelocation) && !isActuallyAssigned) return 'gray';

  // unassigned regular bookings (not checked-in) should be gray
  const isCheckedIn = job?.paxPositionInfo?.activity === "Checked-in" || job?.originalBookingDoc?.paxPositionInfo?.activity === "Checked-in";
  if (!isActuallyAssigned && !job?.completed && !isCheckedIn) return 'gray';

  if (job?.isBreakTask == true) return TaskColors.breakTasks;
  if (job?.completed == true) return TaskColors.completedTasks;
  if (job?.active == true) return TaskColors.ALTPickUps //TaskColors.activeTasks;
  if (job?.cancelled == true) return TaskColors.rejectedTasks;
  if (job?.pending == true) return TaskColors.pendingTasks;
  if (job?.stopped == true) return TaskColors.rejectedTasks;
  if (job?.isGateRelocation && isActuallyAssigned) return TaskColors.gateRelocationTask;
  if (job?.isALTPickUp && !job?.isGateRelocation && !job?.rejectedPax && !job?.rejectedALTPax && isActuallyAssigned) return TaskColors.ALTPickUps;
  if (job?.isAtLocation == true) return '#bd7613';
  if (job?.acknowledged == true) return '#d4d950';
  if (!job?.assignedTime && (job?.originalBookingDoc?.rejectedPax == true || job?.rejectedPax == true || job?.rejectedALTPax == true)) return TaskColors.rejectedTasks;
  if (!job?.assignedTime && (isRejectedArrJourney || isRejectedDepJourney || isRejectedArrPax || isRejectedDepPax)) return TaskColors.rejectedTasks;
  if (job?.assignedTime) { return TaskColors.assignedTask }
  if (job?.paxPositionInfo?.activity == 'Assigned' || job?.paxPositionInfo?.activity == 'assigned') return 'gray';
  if (job?.paxPositionInfo?.activity == 'Confirmed') return TaskColors.acknowledgedTasks;
  // hide it if the task is not assigned
  return "white";
};


export const generateSLAExcel = async (SLAData, exportedFileName, base64Image) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('SLA Report');
  const { inboundNonPreAdvised,
    inboundPreAdvised,
    outboundNonPreAdvised,
    outboundPreAdvised,
    arrivalsCancelledNonPreAdvised,
    arrivalsCancelledPreAdvised,
    departuresCancelledNonPreAdvised,
    departuresCancelledPreAdvised } = SLAData;

  if (base64Image) {
    const imageId = workbook.addImage({
      base64: base64Image,
      extension: 'png', // Change this based on your image type ('png', 'jpeg', etc.)
    });
    // Add the image to the first row
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 }, // Top-left corner (col: 0 is column A, row: 0 is the first row)
      ext: { width: 200, height: 80 }, // Width and height in points
    });
  }
  // Adjust row height to accommodate the image
  worksheet.getRow(1).height = 60;


  // Set column widths for both OUTBOUND and INBOUND sections
  worksheet.columns = [
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
  ];

  // OUTBOUND Section
  const outboundRow = worksheet.addRow(['OUTBOUND']);
  worksheet.mergeCells(`A${outboundRow.number}:N${outboundRow.number}`); // Dynamic merge for OUTBOUND header
  outboundRow.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFADD8E6' }, // Light blue color
  };
  outboundRow.getCell(1).font = { bold: true };
  outboundRow.getCell(1).alignment = { horizontal: 'center', vertical: 'center' }; // Center the text horizontally
  outboundRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Add subheaders for OUTBOUND
  const outboundSubHeaderRow = worksheet.addRow(['SLA - Pre-Advised', '', '', '', '', '', '', 'SLA - Non-Preadvised', '', '', '', '', '', '']);
  worksheet.mergeCells(`A${outboundSubHeaderRow.number}:G${outboundSubHeaderRow.number}`);
  worksheet.mergeCells(`H${outboundSubHeaderRow.number}:N${outboundSubHeaderRow.number}`);
  outboundSubHeaderRow.getCell(1).font = { bold: true };
  outboundSubHeaderRow.getCell(8).font = { bold: true };
  outboundSubHeaderRow.getCell(1).alignment = { horizontal: 'center' }; // Center the subheader
  outboundSubHeaderRow.getCell(8).alignment = { horizontal: 'center' }; // Center the subheader

  // Add column headers for OUTBOUND time ranges
  const outboundTimeHeaderRow = worksheet.addRow(['', '< 10min', '< 20min', '< 30min', '> 30min', 'Disregards', 'TOTAL', '', '< 15min', '< 25min', '< 35min', '> 35min', 'Disregards', 'TOTAL']);
  outboundTimeHeaderRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF00' }, // Yellow background for subheaders
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });
  // Add OUTBOUND data rows
  // const outboundTOTALRow = worksheet.addRow(['TOTAL', 45, 51, 52, 4, 2, 58, 'TOTAL', 12, 12, 12, 2, 0, 14]);
  const outboundTOTALRow = worksheet.addRow(['TOTAL',
    outboundPreAdvised?.lessThan10 ?? 0,
    outboundPreAdvised?.lessThan20 ?? 0,
    outboundPreAdvised?.lessThan30 ?? 0,
    outboundPreAdvised?.moreThan30 ?? 0,
    departuresCancelledPreAdvised,
    departuresCancelledPreAdvised + outboundPreAdvised?.total,
    'TOTAL',
    outboundNonPreAdvised?.lessThan15 ?? 0,
    outboundNonPreAdvised?.lessThan25 ?? 0,
    outboundNonPreAdvised?.lessThan35 ?? 0,
    outboundNonPreAdvised?.moreThan35 ?? 0,
    departuresCancelledNonPreAdvised,
    departuresCancelledNonPreAdvised + outboundNonPreAdvised?.total
  ]);
  outboundTOTALRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  const outboundACTUALRow = worksheet.addRow(['ACTUAL %',
    `${!isNaN((outboundPreAdvised?.lessThan10 / outboundPreAdvised?.total) * 100) ? Math.round((outboundPreAdvised?.lessThan10 / outboundPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((outboundPreAdvised?.lessThan20 / outboundPreAdvised?.total) * 100) ? Math.round((outboundPreAdvised?.lessThan20 / outboundPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((outboundPreAdvised?.lessThan30 / outboundPreAdvised?.total) * 100) ? Math.round((outboundPreAdvised?.lessThan30 / outboundPreAdvised?.total) * 100) : 0}%`,
    '',
    '',
    '',
    'ACTUAL %',
    `${!isNaN((outboundNonPreAdvised?.lessThan15 / outboundNonPreAdvised?.total) * 100) ? Math.round((outboundNonPreAdvised?.lessThan15 / outboundNonPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((outboundNonPreAdvised?.lessThan25 / outboundNonPreAdvised?.total) * 100) ? Math.round((outboundNonPreAdvised?.lessThan25 / outboundNonPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((outboundNonPreAdvised?.lessThan35 / outboundNonPreAdvised?.total) * 100) ? Math.round((outboundNonPreAdvised?.lessThan35 / outboundNonPreAdvised?.total) * 100) : 0}%`,
    '',
    '',
    '']);
  outboundACTUALRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  const outboundTARGETRow = worksheet.addRow(['TARGET %', '80%', '90%', '100%', '', '', '', 'TARGET %', '80%', '90%', '100%', '', '', '']);
  outboundTARGETRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  // Leave a gap between OUTBOUND and INBOUND
  const emptyRow1 = worksheet.addRow([]);
  worksheet.mergeCells(`A${emptyRow1.number}:N${emptyRow1.number}`);
  emptyRow1.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF' }, // Yellow background for subheaders
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'none' },
      bottom: { style: 'none' },
      right: { style: 'none' },
    };
  });
  const emptyRow2 = worksheet.addRow([]);
  worksheet.mergeCells(`A${emptyRow2.number}:M${emptyRow2.number}`);
  // INBOUND Section
  const inboundRow = worksheet.addRow(['INBOUND']);
  worksheet.mergeCells(`A${inboundRow.number}:N${inboundRow.number}`); // Dynamic merge for INBOUND header
  inboundRow.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFADD8E6' }, // Light blue color
  };
  inboundRow.getCell(1).font = { bold: true };
  inboundRow.getCell(1).alignment = { horizontal: 'center', vertical: 'center' }; // Center the text horizontally
  inboundRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
  // Add subheaders for INBOUND
  const inboundSubHeaderRow = worksheet.addRow(['SLA - Pre-Advised', '', '', '', '', '', '', 'SLA - Non-Preadvised', '', '', '', '', '', '']);
  worksheet.mergeCells(`A${inboundSubHeaderRow.number}:G${inboundSubHeaderRow.number}`);
  worksheet.mergeCells(`H${inboundSubHeaderRow.number}:N${inboundSubHeaderRow.number}`);
  inboundSubHeaderRow.getCell(1).font = { bold: true };
  inboundSubHeaderRow.getCell(8).font = { bold: true };
  inboundSubHeaderRow.getCell(1).alignment = { horizontal: 'center' }; // Center the subheader
  inboundSubHeaderRow.getCell(8).alignment = { horizontal: 'center' }; // Center the subheader

  // Add column headers for INBOUND time ranges
  const inboundTimeHeaderRow = worksheet.addRow(['', '< 10min', '< 20min', '< 30min', '> 30min', 'Disregards', 'TOTAL', '', '< 15min', '< 25min', '< 35min', '> 35min', 'Disregards', 'TOTAL']);
  inboundTimeHeaderRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF00' }, // Yellow background for subheaders
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });
  // Add INBOUND data rows
  const inboundTOTALRow = worksheet.addRow(['TOTAL',
    inboundPreAdvised?.lessThan10 ?? 0,
    inboundPreAdvised?.lessThan20 ?? 0,
    inboundPreAdvised?.lessThan30 ?? 0,
    inboundPreAdvised?.moreThan30 ?? 0,
    arrivalsCancelledPreAdvised,
    arrivalsCancelledPreAdvised + inboundPreAdvised?.total,
    'TOTAL',
    inboundNonPreAdvised?.lessThan15 ?? 0,
    inboundNonPreAdvised?.lessThan25 ?? 0,
    inboundNonPreAdvised?.lessThan35 ?? 0,
    inboundNonPreAdvised?.moreThan35 ?? 0,
    arrivalsCancelledNonPreAdvised,
    arrivalsCancelledNonPreAdvised + inboundNonPreAdvised?.total
  ]);
  inboundTOTALRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  const inboundACTUALRow = worksheet.addRow(['ACTUAL %',
    `${!isNaN((inboundPreAdvised?.lessThan10 / inboundPreAdvised?.total) * 100) ? Math.round((inboundPreAdvised?.lessThan10 / inboundPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((inboundPreAdvised?.lessThan20 / inboundPreAdvised?.total) * 100) ? Math.round((inboundPreAdvised?.lessThan20 / inboundPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((inboundPreAdvised?.lessThan30 / inboundPreAdvised?.total) * 100) ? Math.round((inboundPreAdvised?.lessThan30 / inboundPreAdvised?.total) * 100) : 0}%`,
    '',
    '',
    '',
    'ACTUAL %',
    `${!isNaN((inboundNonPreAdvised?.lessThan15 / inboundNonPreAdvised?.total) * 100) ? Math.round((inboundNonPreAdvised?.lessThan15 / inboundNonPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((inboundNonPreAdvised?.lessThan25 / inboundNonPreAdvised?.total) * 100) ? Math.round((inboundNonPreAdvised?.lessThan25 / inboundNonPreAdvised?.total) * 100) : 0}%`,
    `${!isNaN((inboundNonPreAdvised?.lessThan35 / inboundNonPreAdvised?.total) * 100) ? Math.round((inboundNonPreAdvised?.lessThan35 / inboundNonPreAdvised?.total) * 100) : 0}%`,
    '',
    '',
    '']);
  inboundACTUALRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  const inboundTARGETRow = worksheet.addRow(['TARGET %', '80%', '90%', '100%', '', '', '', 'TARGET %', '80%', '90%', '100%', '', '', '']);
  inboundTARGETRow.eachCell((cell) => {
    cell.alignment = {
      horizontal: 'center'
    };
  });
  // Generate Excel file buffer
  const buffer = await workbook.xlsx.writeBuffer();
  const downloadUrl = window.URL.createObjectURL(new Blob([buffer]));

  const link = document.createElement("a");

  link.href = downloadUrl;

  link.setAttribute("download", `${exportedFileName}.xlsx`); //any other extension

  document.body.appendChild(link);

  link.click();
  return null;

};

export const generateAirlinePerformanceExcel = async (AirlinePerformanceData, exportedFileName, base64Image) => {
  // Create new Excel file
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Airline Performance Report");
  worksheet.properties.showGridLines = false;

  // Get date from file name
  const dateMatch = exportedFileName.match(/AirlinePerformance-Report-(\w{3})-(\d{4}-\d{2}-\d{2})-(\d{4}-\d{2}-\d{2})/);
  const iata = dateMatch?.[1] ?? "N/A";
  const startDate = dateMatch?.[2] ?? "N/A";
  const endDate = dateMatch?.[3] ?? "N/A";
  // Uses logobase64 if exists, if not uses airport logo and default prm logo
  let logoBase64 = base64Image;
  if (!base64Image) {
    try {
      const logoElement = ReactDOMServer.renderToString(
        <AirportLogos iata={iata} style={{ display: "none" }} />
      );
      const srcMatch = logoElement.match(/src="([^"]+)"/);
      if (srcMatch && srcMatch[1]) {
        const response = await fetch(srcMatch[1]);
        const blob = await response.blob();
        logoBase64 = await blobToBase64(blob);
      }
      if (!logoBase64) {
        console.warn(`No logo found for IATA: ${iata}, using PRM fallback.`);
        const fallbackResponse = (PRMLogo);
        const fallbackBlob = await fallbackResponse.blob();
        logoBase64 = await blobToBase64(fallbackBlob);
      }
    } catch (error) {
      console.error("Error resolving logo, falling back to PRM logo:", error);
      const fallbackResponse = (PRMLogo);
      const fallbackBlob = await fallbackResponse.blob();
      logoBase64 = await blobToBase64(fallbackBlob);
    }
  }

  // Add the logo to the Excel sheet
  if (logoBase64) {
    const imageId = workbook.addImage({
      base64: logoBase64,
      extension: "png",
    });
    worksheet.addImage(imageId, {
      tl: { col: 6, row: 0 },
      ext: { width: 200, height: 80 },
    });
  }

  // Header
  worksheet.mergeCells("A1:I1");
  const titleRow = worksheet.getRow(1);
  titleRow.getCell(1).value = "Airline Performance";
  titleRow.getCell(1).font = { size: 20, bold: true };
  titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
  titleRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
  titleRow.eachCell((cell) => {
    cell.border = {
      top: { style: "none" },
      left: { style: "none" },
      bottom: { style: "none" },
      right: { style: "none" },
    };
  });
  titleRow.height = 50;

  // Airport with iata
  worksheet.mergeCells("A2:I2");
  const airportRow = worksheet.getRow(2);
  airportRow.getCell(1).value = `Airport: ${iata}`;
  airportRow.getCell(1).font = { size: 14, bold: true };
  airportRow.getCell(1).alignment = { horizontal: "left" };
  airportRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
  airportRow.eachCell((cell) => {
    cell.border = {
      top: { style: "none" },
      left: { style: "none" },
      bottom: { style: "none" },
      right: { style: "none" },
    };
  });

  // Dates from which data was collected
  worksheet.mergeCells("A3:I3");
  const dateRow = worksheet.getRow(3);
  dateRow.getCell(1).value = `Date: ${startDate} - ${endDate}`;
  dateRow.getCell(1).font = { size: 14, bold: false };
  dateRow.getCell(1).alignment = { horizontal: "left" };
  dateRow.getCell(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFFFF" } };
  dateRow.eachCell((cell) => {
    cell.border = {
      top: { style: "none" },
      left: { style: "none" },
      bottom: { style: "none" },
      right: { style: "none" },
    };
  });

  worksheet.getRow(4).height = 30;

  // Style the headers for columns in table
  const styleHeader = (row) => {
    row.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "adc7e0" } };
      cell.border = {
        top: { style: "medium", color: { argb: "FF000000" } },
        left: { style: "medium", color: { argb: "FF000000" } },
        bottom: { style: "medium", color: { argb: "FF000000" } },
        right: { style: "medium", color: { argb: "FF000000" } },
      };
    });
  };

  // Style the data rows in table
  const styleDataRow = (row) => {
    row.eachCell((cell) => {
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "medium", color: { argb: "FF000000" } },
        left: { style: "medium", color: { argb: "FF000000" } },
        bottom: { style: "medium", color: { argb: "FF000000" } },
        right: { style: "medium", color: { argb: "FF000000" } },
      };
    });
  };

  worksheet.columns = [
    { width: 10 },
    { width: 25 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
  ];

  // Function to create table
  const createTable = (title, data, startingRow, headers, addTotals = false, highlightColumnIndex = null, mergeColumns = 9) => {
    worksheet.mergeCells(`A${startingRow}:` + String.fromCharCode(64 + mergeColumns) + `${startingRow}`);
    // title for table
    const titleRow = worksheet.getRow(startingRow);
    titleRow.getCell(1).value = title;
    titleRow.getCell(1).font = { bold: true, size: 14 };
    titleRow.getCell(1).alignment = { horizontal: "center" };
    titleRow.getCell(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "7393B3" },
    };
    const titleRange = worksheet.getCell(`A${startingRow}`);
    titleRange.border = {
      top: { style: "medium", color: { argb: "FF000000" } },
      left: { style: "medium", color: { argb: "FF000000" } },
      bottom: { style: "medium", color: { argb: "FF000000" } },
      right: { style: "medium", color: { argb: "FF000000" } },
    };
    startingRow++;

    // headers for columns
    const headerRow = worksheet.getRow(startingRow);
    headerRow.values = headers;
    styleHeader(headerRow);
    startingRow++;

    // get data 
    let totalPreAdvised = 0;
    let totalNonAdvised = 0;
    let totalWalkUps = 0;
    let grandTotal = 0;

    data.forEach((row, index) => {
      const dataRow = worksheet.getRow(startingRow);
      dataRow.values = [index + 1, ...Object.values(row)];
      styleDataRow(dataRow);

      // highlight relevant column in yellow
      if (highlightColumnIndex !== null) {
        const highlightCell = dataRow.getCell(highlightColumnIndex);
        highlightCell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFAA0" },
        };
      }

      // update totals
      totalPreAdvised += parseFloat(row.preAdvised || 0);
      totalNonAdvised += parseFloat(row.nonPreAdvised || 0);
      grandTotal += parseFloat(row.total || 0);
      totalWalkUps += parseFloat(row.walkUps || 0);
      startingRow++;
    });

    // add totals row if applicable
    if (addTotals) {
      const totalsRow = worksheet.getRow(startingRow);
      totalsRow.values = [
        "", // rank
        "Total",
        totalPreAdvised,
        totalNonAdvised,
        totalWalkUps,
        `${((totalPreAdvised / grandTotal) * 100).toFixed(2)}%`,
        `${(((totalNonAdvised + totalWalkUps) / grandTotal) * 100).toFixed(2)}%`,
        grandTotal,
        "100%", // total% should always be 100
      ];
      // colour row in grey
      totalsRow.eachCell((cell, colIndex) => {
        cell.font = { bold: true };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCCCCC" } };
        cell.alignment = { horizontal: "center" };
        cell.border = {
          top: { style: "medium", color: { argb: "FF000000" } },
          left: { style: "medium", color: { argb: "FF000000" } },
          bottom: { style: "medium", color: { argb: "FF000000" } },
          right: { style: "medium", color: { argb: "FF000000" } },
        };
      });
      startingRow++;
    }

    return startingRow + 2; // Spacer row
  };

  // if total no. passengers is 0, remove
  const filteredData = AirlinePerformanceData.allBookings.filter((booking) => booking.total > 0);

  const preAdvisedData = filteredData.map((booking) => {
    const { airlineName, preAdvised, nonPreAdvised, total, walkUps } = booking;
    const preAdvisedPercent = total > 0 ? (preAdvised / total) * 100 : 0;
    const nonAdvisedPercent = total > 0 ? ((nonPreAdvised + walkUps) / total) * 100 : 0;
    const totalPercent = filteredData.reduce((sum, row) => sum + row.total, 0) > 0 ? (total / filteredData.reduce((sum, row) => sum + row.total, 0)) * 100 : 0;
    return {
      airlineName,
      preAdvised,
      nonPreAdvised,
      walkUps,
      preAdvisedPercent: `${preAdvisedPercent.toFixed(2)}%`,
      nonAdvisedPercent: `${nonAdvisedPercent.toFixed(2)}%`,
      total,
      totalPercent: `${totalPercent.toFixed(2)}%`,
    };
  });

  // volume data, sort by total%, highest to lowest
  const volumeRankingData = [...preAdvisedData];
  volumeRankingData.sort((a, b) => b.total - a.total);

  // airline performance data, sort lowest total rank to highest
  const performanceData = preAdvisedData.map((booking) => {
    const preAdvisedRank = preAdvisedData.findIndex((b) => b.airlineName === booking.airlineName) + 1;
    const volumeRank = volumeRankingData.findIndex((b) => b.airlineName === booking.airlineName) + 1;
    return {
      airlineName: booking.airlineName,
      preAdvisedRank,
      volumeRank,
      totalRank: preAdvisedRank + volumeRank,
    };
  });

  // summary data, rank by total%
  const summaryData = preAdvisedData
    .sort((a, b) => parseFloat(b.totalPercent) - parseFloat(a.totalPercent))
    .map((booking) => {
      const { airlineName, preAdvisedPercent, totalPercent } = booking;
      const airlineCode = AirlinePerformanceData.allBookings.find((b) => b.airlineName === booking.airlineName)?.airlineCode;
      return {
        airlineName,
        airlineCode,
        preAdvisedPercent: preAdvisedPercent,
        totalPercent: totalPercent
      };
    })


  // create tables
  let nextRow = createTable("Pre-Advised Ranking", preAdvisedData, 5, [
    "Rank",
    "Airline Name",
    "Total Pre-Advised",
    "Total Non-Advised",
    "Total Walk-Ups",
    "Pre-Advised%",
    "Non-Advised%",
    "Total",
    "Total%",
  ], true, 6, 9);

  nextRow = createTable("PRM Volume Ranking", volumeRankingData, nextRow, [
    "Rank",
    "Airline Name",
    "Total Pre-Advised",
    "Total Non-Advised",
    "Total Walk-Ups",
    "Pre-Advised%",
    "Non-Advised%",
    "Total",
    "Total%",
  ], true, 9, 9);

  nextRow = createTable("Airline Performance", performanceData, nextRow, [
    "Rank",
    "Airline",
    "Pre-Advised Rank",
    "PRM Volume Rank",
    "Total Rank",
  ], false, 1, 5);

  nextRow = createTable(`Summary: ${startDate} - ${endDate}`, summaryData, nextRow, [
    "Rank",
    "Airline",
    "Airline Code",
    "Pre-Advised%",
    "Total%",
  ], false, 1, 5);

  // workbook converted to buffer, make file downloadable
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = `${exportedFileName}.xlsx`;
  link.click();
};

// function to convert a Blob to Base64 for logo
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result?.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

// function to convert string into string that starts with cap and everything else lowercase
export const capitalizeWords = (str) => {
  if (!str) return "No Name"
  return str
    .toLowerCase()
    .replace(/(^|\s)\S/g, (match) => match.toUpperCase());
}

// function to format assistance array into string
export const formatTimeLineDashboardAssistance = (assistance) => {
  if (Array.isFullArray(assistance)) {
    let tempAssistance = getAssistanceArray(assistance);
    if (tempAssistance?.length > 1) return tempAssistance?.slice(0, 1)?.[0] + "...+" + (tempAssistance?.length - 1);
    else return tempAssistance?.[0]
  } else return "WCHR"
};

export function capitalize(str) {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
}


export function processName(paxName, removePrefix) {
  if (!paxName) return "N/A";
  if (paxName === "Pax 1" || paxName.toLowerCase() === "n/a") return paxName;

  const fullName = paxName.trim()?.split(" ");
  const first = fullName[0] ?? "";
  const rest = fullName.slice(1).join(" ");

  const upper = first.toUpperCase();

  const knownSuffixes = [
    { suffix: "MRS", label: "Mrs" },
    { suffix: "MS", label: "Ms" },
    { suffix: "MR", label: "Mr" },
    { suffix: "MISS", label: "Miss" },
  ];

  for (const { suffix, label } of knownSuffixes) {
    if (upper.endsWith(suffix)) {
      const baseFirst = capitalize(first.slice(0, -suffix.length));
      const capitalizedRest = capitalizeWords(rest);

      if (removePrefix) {
        return `${baseFirst} ${capitalizedRest}`.trim();
      } else {
        return `${label} ${baseFirst} ${capitalizedRest}`.trim();
      }
    }
  }

  // No known prefix found
  return `${capitalize(first)} ${capitalizeWords(rest)}`.trim();
}


export function searchTasks(task, searchedBooking, searchedFlight) {

  let matched = false;
  let flightText = searchedFlight;
  if (flightText.includes("EZY")) flightText = flightText.replace("EZY", "U2")
  // clean name string
  const paxName = task?.passengerInformation?.title
    ? task?.passengerInformation?.title.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
    : "";
  // // clean search term
  const paxSearchTerm = searchedBooking.replace(/[^a-zA-Z0-9]/g, '')?.toLowerCase();
  if (paxName.includes(paxSearchTerm)) matched = true;
  let flight = task?.flightInformation?.flightNumber
    ? task?.flightInformation?.flightNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
    : "";
  // if (flight.includes("U2")) {
  //   flight.replace("U2", "EZY")
  // }
  const flightSearchTerm = flightText.replace(/[^a-zA-Z0-9]/g, '')?.toUpperCase();
  if (flight.includes(flightSearchTerm)) matched = true;
  return matched
};

export function createDuplicates(obj, duplicatesArray) {
  const duplicateCount = obj?.duplicateCount;

  if (duplicateCount) {
    for (let i = 0; i < duplicateCount; i++) {
      let newObj = {
        doc: {
          ...obj,
          _id: obj?._id + "-part" + (i + 1),
          status: "user-confirmed",                     // set to user confirmed status
          name: obj?.name + " " + "PART-" + (i + 1),    // set name to include part number
          duplicateVersion: i
        }

      }; // clone the object
      if (newObj?.doc?.selectArrivalPaxStatus) delete newObj.doc.selectArrivalPaxStatus

      duplicatesArray.push(newObj)

    }
  }
}

export const getHalfHourInterval = (time) => {
  if (time) {
    const [hours, minutes] = time?.split(':').map(Number);

    // Determine if it fits into the lower or upper half-hour interval
    if (minutes < 30) {
      return `${String(hours).padStart(2, '0')}:00`;
    } else {
      return `${String(hours).padStart(2, '0')}:30`;
    }
  }
};

// takes time string and returns back 5 minute interval
export function extractTimeFromISO(isoString) {
  // Create a Date object from the ISO string
  const date = new Date(isoString);

  // Extract hours and minutes
  const hours = date.getUTCHours().toString().padStart(2, '0');
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  // Return the formatted string
  return `${hours}:${minutes}`;
};

export const getHalfHour = (time) => {
  let dateValue = new Date(time);
  let hour = dateValue.getHours();
  let minutes = dateValue.getMinutes();
  let interval = minutes < 30 ? "00" : "30";
  return `${hour < 10 ? "0" : ""}${hour}:${interval}`;
};

export const getIntervalIndex = (date) => {
  // Extract hours and minutes from the Date object
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Calculate the minute offset within the 30-minute window
  const minutesWithin30 = minutes % 30;

  // Determine the 5-minute interval index
  const intervalIndex = Math.floor(minutesWithin30 / 5);

  return intervalIndex;
};

// process a list of flights into intervals
export const processFlightsByInterval = (flightsList) => {
  const flightNumbersByHour = {};

  flightsList.forEach((flight) => {
    const flightTime = new Date(flight.operationInfo.time);
    const halfHour = getHalfHour(flightTime); // Get the 30-minute interval
    const index = getIntervalIndex(flightTime); // Get the 5-minute interval index

    // Ensure the halfHour exists in the object
    if (!flightNumbersByHour[halfHour]) {
      flightNumbersByHour[halfHour] = {};
    }

    // Check if the index exists in the halfHour
    if (!flightNumbersByHour[halfHour][index]) {
      // No flights exist for this interval index, initialize it
      flightNumbersByHour[halfHour][index] = [flight.flightNumber];
    } else {
      // Flights already exist for this interval index, add this flight
      flightNumbersByHour[halfHour][index].push(flight.flightNumber);
    }
  });

  return flightNumbersByHour;
};

//#region merges the flight intervals
export const mergeFlightIntervals = (obj1, obj2) => {
  const combined = { ...obj1 }; // Start with a shallow copy of the first object

  Object.keys(obj2).forEach((halfHour) => {
    if (!combined[halfHour]) {
      // If the halfHour key doesn't exist in obj1, copy it from obj2
      combined[halfHour] = obj2[halfHour];
    } else {
      // Merge the indexes within the halfHour key
      Object.keys(obj2[halfHour]).forEach((index) => {
        if (!combined[halfHour][index]) {
          // If the index key doesn't exist, copy it
          combined[halfHour][index] = obj2[halfHour][index];
        } else {
          // If the index key exists, concatenate the arrays
          combined[halfHour][index] = combined[halfHour][index].concat(obj2[halfHour][index]);
        }
      });
    }
  });

  return combined;
};

export const formatTimeToNearest30 = () => {
  const currentDate = new Date();
  let hour = currentDate.getHours();
  const minute = currentDate.getMinutes();

  // Determine the rounded-down minute
  const roundedMinute = minute < 30 ? 0 : 30;

  // Format the hour and minute as two-digit strings
  const formattedHour = String(hour).padStart(2, "0");
  const formattedMinute = String(roundedMinute).padStart(2, "0");

  return `${formattedHour}:${formattedMinute}`;
}

export const formatHourToNearest30Minutes = (date) => {
  const currentDate = new Date(date);
  let hour = currentDate.getHours();
  const minute = currentDate.getMinutes();

  // Determine the rounded-down minute
  const roundedMinute = minute < 30 ? 0 : 30;

  // Format the hour and minute as two-digit strings
  const formattedHour = String(hour).padStart(2, "0");
  const formattedMinute = String(roundedMinute).padStart(2, "0");

  return `${formattedHour}:${formattedMinute}`;
}

export const getFiveMinuteIntervalIndex = (date) => {
  // Extract the current minutes and hours from the Date object
  const minutes = date.getMinutes();
  const hours = date.getHours();

  // Calculate total minutes since the start of the day
  const totalMinutes = hours * 60 + minutes;

  // Find the minutes within the 30-minute block
  const minutesInBlock = totalMinutes % 30;

  // Calculate the index (0-5)
  const index = Math.floor(minutesInBlock / 5);

  return index;
}

const getBookingEstimatedHour = (time, dueTime) => {
  // check if there's no duetime put a 2 hours 
  let tempDueTime = dueTime ? dueTime : 2
  let dateValue = new Date(time);
  let hour = dateValue.getHours();
  let dueHour = hour - tempDueTime
  return `${dueHour < 10 ? "0" : ""}${dueHour}:00`;
};

export const normalizeText = (text) => String(text || "").trim();

const getBookingEstimatedHalfHour = (time, dueTime) => {
  // Default dueTime is 2 hours
  let tempDueTime = dueTime || 2;
  let dateValue = new Date(time);
  let halfHour = getHalfHour(dateValue); // Get the 30-minute interval
  let hourParts = halfHour?.split(":"); // Split into hours and minutes
  let adjustedHours = parseInt(hourParts[0], 10) - tempDueTime;
  if (adjustedHours < 0) adjustedHours = 24 + adjustedHours; // Handle negative hours (wrap around midnight)
  return `${String(adjustedHours).padStart(2, "0")}:${hourParts[1]}`;
};

export const searchFlightFeed = (flight, searchedFlight) => {
  if (flight && searchedFlight) {
    const flightText = searchedFlight?.replace("EZY", "U2")?.replace(/\s+/g, '');

    let formattedFlightNumber = flight.flightNumber + "_" + flight?.departureAirport + "_" + flight?.arrivalAirport;
    let searchTerm = flightText.replace(/[a-z]+/g, match => match?.toUpperCase());
    return formattedFlightNumber.includes(searchTerm);
  } else return true
}
export const formatFLightFeedByHour = (isThirtyMinLayout, flights, locationList, flightNumbersByHour, preBoard, isALTPickUp, searchedFlight, bookingType, checkedInBookings, ALTPickUpFlights = []) => {

  flights.forEach((flight) => {
    // Skip null/undefined flights or flights without operationInfo
    if (!flight || !flight.operationInfo) return;

    const isSearchedFlight = searchFlightFeed(flight, searchedFlight);

    if (!isSearchedFlight) return; // skip if the flight doesn't match the search term

    const flightTime = new Date(flight.operationInfo.time);
    const hour = flightTime.getHours();
    const halfHour = getHalfHour(flightTime); // Get the 30-minute interval
    const estimatedHour = getBookingEstimatedHour(flightTime, 2);
    const estimatedHalfHour = getBookingEstimatedHalfHour(flightTime, 2);

    const boardHour = flightTime ? new Date(flightTime?.getTime() - 30 * 60 * 1000).getHours() : null; // subtract 30 minutes to the flight time for pre-boarding
    const boardHalfHour = getHalfHour(new Date(flightTime?.getTime() - 30 * 60 * 1000));

    const formattedHour = `${String(hour).padStart(2, '0')}:00`;
    const formattedBoardHour = `${String(boardHour)?.padStart(2, '0')}:00`;

    if (locationList.length > 0) {
      // need to filter by location gates / stands
      if (locationList.includes(`GATE:${flight.gate}`) || locationList.includes(`STAND:${flight.stand}`)) {

        if (preBoard && flight?.type === "departure") {
          // const tempFlightNumber = flight.flightNumber + "/" + "Estimated" + "_" + flight?.departureAirport + "_" + flight?.arrivalAirport;
          // flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(tempFlightNumber);
          const prBoardFlightNumber = `${flight.flightNumber}_${flight?.departureAirport}_${flight?.arrivalAirport}`;
          // //check if bookingType filter includes checkedIn filter departureBooking to only bookings that have paxPositionInfo
          if (!bookingType?.some(type => ["all", "departures"].includes(type)) && bookingType?.some(type => ["checkedIn"].includes(type))) {
            const checkedInBookingsFlights = [...new Set(checkedInBookings?.map((item) => item?.doc?.flightConfirmationDetails?.carrierCode + item?.doc?.flightConfirmationDetails?.flightNumber))];
            if (checkedInBookingsFlights.includes(flight.flightNumber)) {
              flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
            }
          } else if (bookingType?.some(type => ["all", "departures"].includes(type))) {
            flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
          }


          if (bookingType?.some(type => ["all", "boarding"].includes(type))) {
            const boardingFlightNumber = `${flight.flightNumber}/boarding_${flight?.departureAirport}_${flight?.arrivalAirport}`;
            flightNumbersByHour[isThirtyMinLayout ? boardHalfHour : formattedBoardHour]?.push(boardingFlightNumber);
          }
          if (bookingType?.some(type => ["all", "ALTPickUp"].includes(type)) && ALTPickUpFlights?.length > 0) {
            if (ALTPickUpFlights.includes(flight.flightNumber)) {

              flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
            }
          }
        } else if (isALTPickUp) {
          const ALTPickupHalfHour = flight?.isFor === "ALTPICKUP" ?
            getHalfHour(flight?.formattedTimeForDisplay) // Get the 30-minute interval
            : halfHour;
          const ALTPickupHour = flight?.isFor === "ALTPICKUP" ? new Date(flight?.formattedTimeForDisplay)?.getHours() : hour;
          const formattedALTPickupHour = `${String(ALTPickupHour).padStart(2, '0')}:00`;

          const tempFlightNumber = flight?.isFor === "ALTPICKUP"
            ? `${flight.flightNumber}/ALTPickUp_${flight?.departureAirport}_${flight?.arrivalAirport}_pickupTime_${flight?.formattedTimeForDisplay}_${flight?.pickUpLocation?.id}`
            : `${flight.flightNumber}/ALTPickUp_${flight?.departureAirport}_${flight?.arrivalAirport}`;
          flightNumbersByHour[isThirtyMinLayout ? ALTPickupHalfHour : formattedALTPickupHour]?.push(tempFlightNumber);

        } else {
          const tempFlightNumber = flight.flightNumber + "_" + flight?.departureAirport + "_" + flight?.arrivalAirport;
          flightNumbersByHour[isThirtyMinLayout ? halfHour : formattedHour]?.push(tempFlightNumber);
        }
      } else {
        return;
      }
    }
    else {
      if (preBoard && flight?.type === "departure") {
        const prBoardFlightNumber = `${flight.flightNumber}_${flight?.departureAirport}_${flight?.arrivalAirport}`;
        // //check if bookingType filter includes checkedIn filter departureBooking to only bookings that have paxPositionInfo
        if (!bookingType?.some(type => ["all", "departures"].includes(type)) && bookingType?.some(type => ["checkedIn"].includes(type))) {
          const checkedInBookingsFlights = [...new Set(checkedInBookings?.map((item) => item?.doc?.flightConfirmationDetails?.carrierCode + item?.doc?.flightConfirmationDetails?.flightNumber))];
          if (checkedInBookingsFlights.includes(flight.flightNumber)) {
            flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
          }
        } else if (bookingType?.some(type => ["all", "departures"].includes(type))) {
          flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
        }
        // flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
        if (bookingType?.some(type => ["all", "boarding"].includes(type))) {
          const boardingFlightNumber = `${flight.flightNumber}/boarding_${flight?.departureAirport}_${flight?.arrivalAirport}`;
          flightNumbersByHour[isThirtyMinLayout ? boardHalfHour : formattedBoardHour]?.push(boardingFlightNumber);
        };

        if (bookingType?.some(type => ["all", "ALTPickUp"].includes(type)) && ALTPickUpFlights?.length > 0) {
          if (ALTPickUpFlights.includes(flight.flightNumber)) {
            flightNumbersByHour[isThirtyMinLayout ? estimatedHalfHour : estimatedHour]?.push(prBoardFlightNumber);
          }
        }
      } else if (isALTPickUp) {
        const ALTPickupHalfHour = flight?.isFor === "ALTPICKUP" ?
          getHalfHour(flight?.formattedTimeForDisplay) // Get the 30-minute interval
          : halfHour;
        const ALTPickupHour = flight?.isFor === "ALTPICKUP" ? new Date(flight?.formattedTimeForDisplay)?.getHours() : hour;
        const formattedALTPickupHour = `${String(ALTPickupHour).padStart(2, '0')}:00`;

        const tempFlightNumber = flight?.isFor === "ALTPICKUP"
          ? `${flight.flightNumber}/ALTPickUp_${flight?.departureAirport}_${flight?.arrivalAirport}_pickupTime_${flight?.formattedTimeForDisplay}_${flight?.pickUpLocation?.id}`
          : `${flight.flightNumber}/ALTPickUp_${flight?.departureAirport}_${flight?.arrivalAirport}`;
        flightNumbersByHour[isThirtyMinLayout ? ALTPickupHalfHour : formattedALTPickupHour]?.push(tempFlightNumber);
      } else {
        const tempFlightNumber = flight.flightNumber + "_" + flight?.departureAirport + "_" + flight?.arrivalAirport;

        flightNumbersByHour[isThirtyMinLayout ? halfHour : formattedHour]?.push(tempFlightNumber);
      }
    }
  })
};

// group ALTPickup tasks by flight number, pickup location, and pickup time
export const groupAndFormatALTPickupTasks = (tasks) => {
  if (!tasks || tasks.length === 0) return [];

  // create a map to group tasks
  const groupedTasksMap = new Map();

  tasks.forEach(task => {
    const flightInfo = task?.flightInformation;
    const pickUpTime = convertToDate(task?.pickUpTime);
    const pickUpLocation = task?.pickUpLocation || '';
    const flightNumber = flightInfo?.flightNumber || '';

    // create a unique key for grouping
    const groupKey = `${flightNumber}_${pickUpLocation}_${new Date(pickUpTime)?.getTime()}`;

    if (!groupedTasksMap.has(groupKey)) {
      groupedTasksMap.set(groupKey, []);
    }

    groupedTasksMap.get(groupKey).push(task);
  });

  // format grouped tasks
  const formattedTasks = [];

  groupedTasksMap.forEach((tasksGroup) => {
    if (tasksGroup.length > 1) {
      // multiple tasks - create a grouped object
      formattedTasks.push(formatGroupedALTPickupTasks(tasksGroup));
    } else {
      // single task - create individual object
      formattedTasks.push(formatALTPickupTaskToFlightsList(tasksGroup[0]));
    }
  });

  return formattedTasks;
};

// format multiple ALTPickup tasks into a single grouped object
const formatGroupedALTPickupTasks = (tasks) => {
  if (!tasks || tasks.length === 0) return null;

  // use the first task as the base for flight information
  const firstTask = tasks[0];
  const flightInfo = firstTask?.flightInformation;
  const flightTime = convertToDate(flightInfo?.flightTime || flightInfo?.departureTime);
  const pickUpTime = convertToDate(firstTask?.pickUpTime);

  // create a unique ID for this grouped ALTPickup
  const uniqueId = `${flightInfo?.flightNumber}_${firstTask?.pickUpLocation?.id}_${new Date(pickUpTime)?.getTime()}_GROUPED_ALTPICKUP`;

  return {
    _id: uniqueId,
    passengers: tasks,
    flightNumber: flightInfo?.flightNumber || "",
    date: flightInfo?.flightDate || flightInfo?.departureDate || "",
    gate: flightInfo?.gate || "N/A",
    terminal: flightInfo?.terminal || "N/A",
    operationInfo: {
      status: "Scheduled",
      statusType: "ALTPickup",
      time: flightTime
    },
    stand: flightInfo?.stand || "",
    type: "departure", // ALTPickup is typically for departures
    createdAt: convertToDate(firstTask?.allocatedTime),
    updatedAt: convertToDate(firstTask?.allocatedTime),
    history: [],
    departureAirport: flightInfo?.departureAirport || "",
    arrivalAirport: flightInfo?.arrivalAirport || "",
    aircraftType: flightInfo?.aircraftType || "N/A",
    aircraftRegistration: flightInfo?.aircraftRegistration || "N/A",
    callSign: flightInfo?.flightNumber || "",
    originalFlightTime: flightTime,
    timeDifference: 0,
    operatingStatus: "On Time",
    manualLock: false,
    // ALTPickup specific fields
    isALTPickUp: true,
    groupedALTPickup: true, // mark as grouped
    pickUpLocation: firstTask?.pickUpLocation || null,
    dropOffLocation: firstTask?.dropOffLocation || null,
    pickUpTime: pickUpTime,
    // add display properties similar to other formatted flights
    isFor: "ALTPICKUP",
    originalFlightId: flightInfo?.flightNumber ?
      `${flightInfo.flightNumber}_${flightInfo.departureAirport}_${flightInfo.arrivalAirport}_${flightInfo.flightDate}_IATA_${flightInfo.departureAirport}` :
      uniqueId,
    formattedTimeForDisplay: pickUpTime || new Date(flightTime.getTime() - 30 * 60 * 1000), // Use pickup time or 30 minutes before flight time
    passengerCount: tasks.length,
    pickUpTime: pickUpTime
  };
};

const formatALTPickupTaskToFlightsList = (task) => {
  const flightInfo = task?.flightInformation;
  const passengerInfo = task?.passengerInformation;

  // create flight time from task's flight information
  const flightTime = convertToDate(flightInfo?.flightTime || flightInfo?.departureTime);

  // create unique ID for this ALTPickup task (since multiple tasks can exist for same flight)
  const uniqueId = `${task?._id}_ALTPICKUP`;

  return {
    _id: uniqueId,
    passengers: [task],
    flightNumber: flightInfo?.flightNumber || "",
    date: flightInfo?.flightDate || flightInfo?.departureDate || "",
    gate: flightInfo?.gate || "N/A",
    terminal: flightInfo?.terminal || "N/A",
    operationInfo: {
      status: "Scheduled",
      statusType: "ALTPickup",
      time: flightTime
    },
    stand: flightInfo?.stand || "",
    type: "departure", // ALTPickup is typically for departures
    createdAt: convertToDate(task?.allocatedTime),
    updatedAt: convertToDate(task?.allocatedTime),
    history: [],
    departureAirport: flightInfo?.departureAirport || "",
    arrivalAirport: flightInfo?.arrivalAirport || "",
    aircraftType: flightInfo?.aircraftType || "N/A",
    aircraftRegistration: flightInfo?.aircraftRegistration || "N/A",
    callSign: flightInfo?.flightNumber || "",
    originalFlightTime: flightTime,
    timeDifference: 0,
    operatingStatus: "On Time",
    manualLock: false,
    // ALTPickup specific fields
    isALTPickUp: true,
    groupedALTPickup: false, // not grouped
    originalALTPaxId: task?.originalALTPaxId || task?._id,
    pickUpLocation: task?.pickUpLocation || null,
    dropOffLocation: task?.dropOffLocation || null,
    taskNotes: task?.taskNotes || null,
    passengerInformation: passengerInfo,
    taskId: task?._id,
    // add display properties similar to other formatted flights
    isFor: "ALTPICKUP",
    originalFlightId: flightInfo?.flightNumber ?
      `${flightInfo.flightNumber}_${flightInfo.departureAirport}_${flightInfo.arrivalAirport}_${flightInfo.flightDate}_IATA_${flightInfo.departureAirport}` :
      uniqueId,
    formattedTimeForDisplay: task?.pickUpTime ? convertToDate(task.pickUpTime) : new Date(flightTime.getTime() - 30 * 60 * 1000), // 30 minutes before flight time
    // passenger details for this specific task
    passengerTitle: passengerInfo?.title || "N/A",
    assistance: passengerInfo?.assistance || [],
    pickUpTime: convertToDate(task?.pickUpTime)
  };
};

export const convertToDate = (timestamp) => {
  if (!timestamp) return null;

  // check if it's a Firebase Timestamp object
  if (timestamp?._seconds !== undefined) {
    const date = new Date(timestamp?._seconds * 1000);
    return isNaN(date.getTime()) ? null : date.toISOString();
  }

  if (timestamp?.seconds !== undefined) {
    const date = new Date(timestamp?.seconds * 1000);
    return isNaN(date.getTime()) ? null : date.toISOString();
  }

  // check if it's already a Date object or can be converted to one
  const date = new Date(timestamp);
  return isNaN(date.getTime()) ? null : date.toISOString();
};


export const formatFlightListFromBookings = (bookingsList, iata, timelineDate) => {
  // Validate input
  if (!Array.isFullArray(bookingsList) || !iata) {
    return [];
  }

  // Use a Map to track unique flights and avoid duplicates
  // Key: flightNumber_origin_destination_timelineDate_IATA_iata
  const flightsMap = new Map();

  bookingsList.forEach((booking) => {
    // Extract booking object (handle both direct objects and doc wrapper)
    const bookingData = booking?.doc || booking;

    // Get flight confirmation details
    const flightDetails = bookingData?.flightConfirmationDetails;

    // Skip if missing flight details
    if (!flightDetails) {
      return;
    }

    // Extract required fields
    const {
      carrierCode,
      flightNumber: bookingFlightNumber,
      origin,
      destination,
      departureDate,
      departureTime,
      arrivalTime
    } = flightDetails;

    // Skip if missing critical information
    if (!carrierCode || !bookingFlightNumber || !origin || !destination || !departureDate) {
      return;
    }

    // Skip bookings with missing time information
    // Some bookings don't have arrivalTime or departureTime, which are required for timeline display
    if (!departureTime || !arrivalTime) {
      console.warn(`[formatFlightListFromBookings] Skipping booking - missing time info:`, bookingData._id);
      return;
    }

    // Determine flight type based on airport IATA code
    // If the origin matches the user's airport, it's a departure
    // If the destination matches the user's airport, it's an arrival
    const flightType = origin === iata ? 'departure' : 'arrival';

    // Construct full flight number (e.g., "FR6806")
    const fullFlightNumber = `${carrierCode}${bookingFlightNumber}`;

    // Create unique key for this flight to prevent duplicates
    const flightKey = `${fullFlightNumber}_${origin}_${destination}_${timelineDate}_IATA_${iata}`;

    // Skip if we've already processed this flight (multiple bookings on same flight)
    if (flightsMap.has(flightKey)) {
      return;
    }

    // Determine the operation time based on flight type
    // For departures: use departure time
    // For arrivals: use arrival time
    let operationTime = flightType === 'departure' ? departureTime : arrivalTime;

    // Normalize time format to handle both formats:
    // Format 1: "2025-11-03T07:50Z" (short format with Z)
    // Format 2: "2025-11-03T07:00:00+00:00" (full format with timezone)
    try {
      const timeDate = new Date(operationTime);
      // Convert to ISO string with full format
      operationTime = timeDate.toISOString();
    } catch (error) {
      console.warn(`[formatFlightListFromBookings] Invalid time format for ${fullFlightNumber}:`, operationTime);
      // Keep original if conversion fails
    }

    // Create flight object matching the expected structure
    const flightObject = {
      _id: flightKey,
      flightNumber: fullFlightNumber,
      date: timelineDate,
      gate: "N/A",
      terminal: "N/A",
      operationInfo: {
        status: "Booking",
        statusType: "Booking",
        time: operationTime
      },
      stand: "N/A",
      type: flightType,
      createdAt: bookingData?.dateCreated || new Date().toISOString(),
      updatedAt: bookingData?.dateCreated || new Date().toISOString(),
      history: [],
      departureAirport: origin,
      arrivalAirport: destination,
      aircraftType: "N/A",
      aircraftRegistration: "N/A",
      callSign: "N/A",
      originalFlightTime: operationTime,
      timeDifference: 0,
      operatingStatus: "On Time",
      manualLock: false,
      cancelled: false,
      // Additional metadata to indicate this flight was created from a booking
      fromBooking: true,
      // bookingId: bookingData._id
    };

    // Add to flights map (ensures uniqueness)
    flightsMap.set(flightKey, flightObject);
  });

  // Convert Map to array and return
  const flightsList = Array.from(flightsMap.values());

  return flightsList;
};
export const getFlightTime = (flightList, flightNumber, ALTPickUpWithPickUpTime = null) => {
  if (!Array.isFullArray(flightList)) return null;
  if (!flightNumber) return null;
  if (ALTPickUpWithPickUpTime?.pickUpTime) {
    const pickUpTimeList = flightList?.filter((f) => f?.pickUpTime);
    if (Array.isFullArray(pickUpTimeList)) {
      const wantedPickUpFlight = pickUpTimeList?.find((f) => f?.flightNumber === flightNumber && convertToDate(f?.pickUpTime) === convertToDate(ALTPickUpWithPickUpTime?.pickUpTime));
      if (!Object.isObjectEmpty(wantedPickUpFlight)) return wantedPickUpFlight?.formattedTimeForDisplay;
      else return null;
    }
  } else {
    const flight = flightList?.find((f) => f?.flightNumber === flightNumber);
    if (!Object.isObjectEmpty(flight)) return flight?.operationInfo?.time;
    else return null;
  }
};

export const parseFlightNumber = (flightNumber) => {
  if (!flightNumber) return "";
  // remove any whitespace and convert to uppercase
  const cleaned = flightNumber.trim().toUpperCase();

  // regular expression to match carrier code (2-3 letters) and flight number (1-4 digits)
  const regex = /^([A-Z]{2,3})(\d{1,4})$/;
  const match = cleaned.match(regex);

  if (match) {
    return {
      carrierCode: match[1],
      flightNumber: match[2]
    };
  }

  // if no match, return empty string
  return "";
}

export const getBookingIdsFromTask = (task) => {
  let bookingIds = []
  if (task._id.includes("selfAllocatedTask")) {
    const originalBookingIds = task.passengers.map(pax => pax.originalBookingId)
    bookingIds = [...originalBookingIds]
  }
  if (task.originalBookingId) bookingIds.push(task.originalBookingId)
  if (!task.originalBookingId && !task._id.includes("selfAllocatedTask") && !task._id.includes("-part") && !task.combinedBooking) bookingIds = [task._id]
  return bookingIds
}

// takes a time string and returns back the correct interval number, so '11:15' would return '11:00' etc.
export const getThirtyMinuteInterval = (time) => {

  const [hours, minutes] = time?.split(':').map(Number);

  // Determine the 30-minute interval
  const roundedMinutes = minutes < 30 ? '00' : '30';

  // Format the interval time as HH:mm
  return `${String(hours).padStart(2, '0')}:${roundedMinutes}`;
};

export const processMissingBookingsTimes = (flights, bookings, type) => {
  if (!Array.isFullArray(flights)) return bookings;
  if (!Array.isFullArray(bookings)) return [];

  return bookings.map((booking) => {
    // If the booking already has the required time, return it as-is
    if (type === "arrivals" && booking?.doc?.flightConfirmationDetails?.arrivalTime) {
      return booking;
    }
    if (type === "departures" && booking?.doc?.flightConfirmationDetails?.departureTime) {
      return booking;
    }

    // Create a deep copy of the booking to avoid modifying the original
    const formattedBooking = JSON.parse(JSON.stringify(booking));
    const timeKey = type === "arrivals" ? "arrivalTime" : "departureTime";

    // Only try to modify if flights array exists

    const flightTime = getFlightTime(
      flights,
      `${formattedBooking?.doc?.flightConfirmationDetails?.carrierCode}${formattedBooking?.doc?.flightConfirmationDetails?.flightNumber}`
    );

    if (flightTime) {
      formattedBooking.doc.flightConfirmationDetails[timeKey] = flightTime;
    }


    return formattedBooking;
  });
};

// take the departures bookings and group them by flight number (ex. U21234 have 5 passengers make them into one booking)
export const createCombinedBookings = (departureBookings) => {
  if (!Array.isFullArray(departureBookings)) return [];

  const grouped = departureBookings.reduce((acc, obj) => {
    const flightNum = obj?.doc?.flightConfirmationDetails?.carrierCode + obj?.doc?.flightConfirmationDetails?.flightNumber;

    if (!acc[flightNum]) {
      acc[flightNum] = [];
    }

    acc[flightNum].push(obj?.doc);

    return acc;
  }, {});

  return Object.keys(grouped).map(flightNum => {
    return {
      id: `${flightNum}-${grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate}-boarding`,
      doc: {
        flightNum,
        _id: `${flightNum}-${grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate}-boarding`,
        flightConfirmationDetails: {
          origin: grouped[flightNum]?.[0]?.flightConfirmationDetails?.origin,
          destination: grouped[flightNum]?.[0]?.flightConfirmationDetails?.destination,
          carrierCode: grouped[flightNum]?.[0]?.flightConfirmationDetails?.carrierCode,
          flightNumber: grouped[flightNum]?.[0]?.flightConfirmationDetails?.flightNumber,
          departureDate: grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate,
          departureTime: grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureTime,
          arrivalTime: grouped[flightNum]?.[0]?.flightConfirmationDetails?.arrivalTime ?? grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureTime

        },
        assistance: [...new Set(grouped[flightNum]?.flatMap(passenger => passenger?.assistance))],
        passengers: grouped[flightNum],
        combinedBooking: true,

      }
    };
  });
};

export const createArrivalBookingsList = (arrivalBooking, iata, arrivalFlights) => {
  if (!Array.isFullArray(arrivalBooking)) return [];
  let flightIndex = {};

  const formattedArrivals = arrivalBooking?.map((booking) => {
    let flightNumber = booking?.doc?.flightConfirmationDetails?.carrierCode + booking?.doc?.flightConfirmationDetails?.flightNumber;
    let tempArrivalTime = booking?.doc?.flightConfirmationDetails?.arrivalTime
      ? booking?.doc?.flightConfirmationDetails?.arrivalTime
      : booking?.doc?.flightConfirmationDetails?.departureTime;
    if (!tempArrivalTime) {
      tempArrivalTime = Array.isFullArray(arrivalFlights) ? getFlightTime(arrivalFlights, flightNumber) : ""
    }
    let bookingTime = iata == booking.doc?.flightConfirmationDetails?.destination
      ? tempArrivalTime
      : booking.doc?.flightConfirmationDetails?.departureTime;
    let flightTime = Array.isFullArray(arrivalFlights) ? getFlightTime(arrivalFlights, flightNumber) : null;

    let flightHour = String(new Date(flightTime ? flightTime : bookingTime).getHours()).padStart(2, '0');

    let index;
    // get index using flightIndex
    if (flightIndex[flightNumber + "_" + flightHour] == undefined) {
      // need to create new index
      flightIndex[flightNumber + "_" + flightHour] = 1;
      index = 1;
    } else {
      // increment index
      index = flightIndex[flightNumber + "_" + flightHour] + 1;
      flightIndex[flightNumber + "_" + flightHour] += 1;
    }
    let matchDuplicateID = booking?.doc?._id?.match(/-part(\d+)$/)
    let flightBooking = {
      'id': booking?.doc?._id?.includes("-part")
        ? `${flightNumber}-${index}-${tempArrivalTime?.split("T")?.[0]}-${matchDuplicateID?.length ? matchDuplicateID?.[0] : ""}`
        : flightNumber + '-' + index + '-' + tempArrivalTime?.split("T")?.[0],
      'doc': {
        '_id': booking?.doc?._id?.includes("-part")
          ? `${flightNumber}-${index}-${tempArrivalTime?.split("T")?.[0]}-${matchDuplicateID?.length ? matchDuplicateID?.[0] : ""}`
          : flightNumber + '-' + index + '-' + tempArrivalTime?.split("T")?.[0],
        'flightConfirmationDetails': {
          ...booking?.doc?.flightConfirmationDetails,
          arrivalTime: tempArrivalTime
        },
        'isTransitBooking': booking?.doc?.isTransitBooking,
        'name': iata === "JER" ? booking.doc.name : 'Pax ' + index,
        'flightBooking': true,
        'originalBookingId': booking?.doc?._id,
        'assistance': booking?.doc?.assistance ?? [],
        'originalBookingDoc': {
          ...booking?.doc,
          flightConfirmationDetails: {
            ...booking?.doc?.flightConfirmationDetails,
            arrivalTime: booking?.doc?.flightConfirmationDetails?.arrivalTime ? booking?.doc?.flightConfirmationDetails?.arrivalTime : tempArrivalTime
          }
        }
      },
    }

    return flightBooking;
  });

  return formattedArrivals;
};


// take the arrival bookings that is in a ramp location and group them by flight number (ex. U21234 have 5 passengers make them into one booking)
export const createCombinedRampBookings = (arrivalBookings, rampBookingsForHCAndHS = false) => {
  const grouped = arrivalBookings.reduce((acc, obj) => {

    // extract the flight number by combining carrierCode and flightNumber
    const flightNum = obj?.doc?.flightConfirmationDetails?.carrierCode + obj?.doc?.flightConfirmationDetails?.flightNumber;

    // if the flightNum key doesn't exist in the accumulator, initialize it as an empty array
    if (!acc[flightNum]) {
      acc[flightNum] = [];
    }

    // push the current booking's doc into the corresponding flightNum array
    acc[flightNum].push(obj?.doc);

    // return the accumulator object for the next iteration
    return acc;
  }, {}); // initial value of accumulator is an empty object `{}`

  let formattedRampBookings = Object.keys(grouped).map(flightNum => {
    return {
      id: `${flightNum}-${grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate}-rampBooking`,
      doc: {
        flightNum,
        _id: `${flightNum}-${grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate}-rampBooking`,
        flightConfirmationDetails: {
          origin: grouped[flightNum]?.[0]?.flightConfirmationDetails?.origin,
          destination: grouped[flightNum]?.[0]?.flightConfirmationDetails?.destination,
          carrierCode: grouped[flightNum]?.[0]?.flightConfirmationDetails?.carrierCode,
          flightNumber: grouped[flightNum]?.[0]?.flightConfirmationDetails?.flightNumber,
          departureDate: grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureDate,
          departureTime: grouped[flightNum]?.[0]?.flightConfirmationDetails?.departureTime ?? "",
          arrivalTime: grouped[flightNum]?.[0]?.flightConfirmationDetails?.arrivalTime ?? "",
        },
        assistance: [...new Set(grouped[flightNum]?.flatMap(passenger => passenger?.assistance))],
        passengers: grouped[flightNum],
        combinedRampBooking: true,
        originalBookingId: grouped[flightNum]?.[0]?.originalBookingId
      }
    };
  });

  // filter out ramp bookings where no passengers have WCHS or WCHC assistance
  if (rampBookingsForHCAndHS) {
    formattedRampBookings = formattedRampBookings.filter(rampBooking => {

      const passengers = rampBooking.doc.passengers || [];

      // check if any passenger has WCHS or WCHC assistance
      return passengers.some(passenger => {
        const assistanceArray = passenger.assistance || [];
        const assistanceString = getAssistanceString(assistanceArray);
        return assistanceString.includes('WCHS') || assistanceString.includes('WCHC');
      });
    });
  }


  return formattedRampBookings;
};

export const formatALTPickUpObject = (ALTPickUpTask, tempCarrierCode, tempFlightNumber, copiedDepartureTime, ALTPickUpTaskFlightNum) => {

  const obj = {
    "_id": ALTPickUpTask?._id,
    "name": ALTPickUpTask?.passengerInformation?.title,
    "flightConfirmationDetails": {
      "carrierCode": tempCarrierCode,
      "flightNumber": tempFlightNumber,
      "origin": ALTPickUpTask?.flightInformation?.departureAirport,
      "destination": ALTPickUpTask?.flightInformation?.arrivalAirport,
      "departureDate": ALTPickUpTask?.flightInformation?.departureDate,
      "departureTime": copiedDepartureTime,
      "arrivalTime": ALTPickUpTask?.flightInformation?.arrivalTime ?? ""
    },
    "status": "both-confirmed",
    "assistance": ALTPickUpTask?.passengerInformation?.assistance,
    "airlineData": null,
    "originalCarrierCode": ALTPickUpTaskFlightNum?.match(/[A-Z]+/)?.[0],
    "dateCreated": ALTPickUpTask?.flightInformation?.flightTime,
    "ignore": false,
    "isALTPickUp": true,
    "taskNotes": ALTPickUpTask.taskNotes ?? "",
    "pickUpLocation": ALTPickUpTask?.pickUpLocation,
    "dropOffLocation": ALTPickUpTask?.dropOffLocation,
    "rejectedPax": ALTPickUpTask?.rejectedALTPax ? true : false,
    "rejectReason": ALTPickUpTask?.rejectReason ? ALTPickUpTask?.rejectReason : null,

  }
  if (ALTPickUpTask?.pickUpTime) obj["pickUpTime"] = ALTPickUpTask?.pickUpTime;
  return obj;
};

const getPassengerDutTime = (date, dueTime) => {

  // create a Date object from the original time string
  const formattedDate = date ? new Date(date) : new Date();
  // subtract the dueTime in hours converted to milliseconds
  formattedDate.setTime(formattedDate.getTime() - dueTime * 60 * 60 * 1000);

  // convert the adjusted Date object back to an ISO string
  const adjustedTime = formattedDate.toISOString();
  return adjustedTime;
}

const getThirtyMinOffsetFlightTime = (date) => {
  // create a Date object from the original time string
  const formattedDate = date ? new Date(date) : new Date();
  // subtract 30 minutes in hours converted to milliseconds
  formattedDate.setTime(formattedDate.getTime() - 30 * 60 * 1000);

  // convert the adjusted Date object back to an ISO string
  const adjustedTime = formattedDate.toISOString();
  return adjustedTime;
}

export const processBookingsToTempList = ({
  thirtyMinLayout,
  tempList = {},
  bookings,
  flightType,
  flightsData,
  taskList,
  preBoard,
  iata,
  isALTPickUp = false,
  departureBookings = [],
  bookingSearch = null,
  showAll = false
}) => {

  if (!Array.isFullArray(bookings)) return tempList;

  bookings.forEach((item) => {
    // handle ALTPickUp specific formatting
    let booking;
    if (isALTPickUp) {
      const ALTPickUpTaskFlightNum = item?.flightInformation?.flightNumber;
      let num = ALTPickUpTaskFlightNum?.match(/\d+/)[0];
      let copiedDepartureTime = '';

      // get the booking time fore the looped ALT pick up
      departureBookings?.forEach((depBooking) => {
        if (depBooking?.doc?.flightConfirmationDetails?.flightNumber == num) {
          // copy flight departure time 
          copiedDepartureTime = depBooking?.doc?.flightConfirmationDetails?.departureTime;
        }
      });

      if (copiedDepartureTime == '') {
        copiedDepartureTime = item?.flightInformation?.flightTime;
      }

      const tempCarrierCode = ALTPickUpTaskFlightNum?.startsWith("U2")
        ? "U2"
        : ALTPickUpTaskFlightNum?.match(/[A-Z]+/)?.[0];
      const tempFlightNumber = ALTPickUpTaskFlightNum?.startsWith("U2")
        ? ALTPickUpTaskFlightNum?.split("U2")?.[1]
        : ALTPickUpTaskFlightNum?.match(/\d+/)[0];

      booking = formatALTPickUpObject(item, tempCarrierCode, tempFlightNumber, copiedDepartureTime, ALTPickUpTaskFlightNum);

    } else {
      booking = item?.doc || item;
    }

    if (bookingSearch) {
      let resultSearchPassenger = searchBooking(booking, bookingSearch);

      // search by flight
      let resultSearchFlight = searchFlights(booking, bookingSearch);

      if (resultSearchPassenger || resultSearchFlight) booking = booking;
      else booking = null;
    }
    if (booking) {
      // skip if passenger is boarded (departures only)
      if ((flightType === 'departures' && booking?.selectBoardingPaxStatus === "boarded") || (flightType === 'departures' && booking?.boardingType === "onlyBoarding")) return;

      const flightDetails = booking?.flightConfirmationDetails;
      if (!flightDetails) return;

      // determine flight number and time
      let flight = `${flightDetails.carrierCode}${flightDetails.flightNumber}`;
      const flightTime = Array.isFullArray(flightsData) ? getFlightTime(flightsData, flight, iata === "JER" || iata === "SNN" ? null : booking) : null;

      // determine booking time based on flight type
      const bookingTime = flightType === 'departures'
        ? flightDetails.departureTime ?? flightDetails.arrivalTime ?? ""
        : flightDetails.arrivalTime ?? flightDetails.departureTime ?? "";

      // format flight hour
      // get the hour of the flight if thirtyMinLayout switch is turned on the flight hour in this format(12:30, 12:00) includes minutes to the nearest thirty minutes
      // else in this format (12:00, 01:00) 
      let flightHour = thirtyMinLayout
        ? formatHourToNearest30Minutes(flightTime ? flightTime : bookingTime)
        : String(new Date(flightTime ? flightTime : bookingTime).getHours()).padStart(2, '0');

      // handle preBoard logic for departures
      if (flightType === 'departures' && preBoard && !isALTPickUp) {

        // check if the preBoard is switched on and if the mapped booking is a combinedBooking add /boarding to the flight
        if (booking?.combinedBooking) {
          const thirtyMinOffsetFlightTime = getThirtyMinOffsetFlightTime(flightTime ? flightTime : flightDetails.departureTime);
          if (thirtyMinOffsetFlightTime) {
            // passengerDutTime refers to the passenger estimated show up in the airport
            flightHour = thirtyMinLayout
              ? formatHourToNearest30Minutes(thirtyMinOffsetFlightTime)
              : String(new Date(thirtyMinOffsetFlightTime).getHours()).padStart(2, '0');
          }
          flight = `${flight}/boarding`;
        } else {
          // check if the preBoard is switched on and if the mapped booking is not combinedBooking change the flight hour to be 2 hours before the original flight hour
          const passengerDutTime = getPassengerDutTime(flightTime ? flightTime : flightDetails.departureTime, 2);
          if (passengerDutTime) {
            // passengerDutTime refers to the passenger estimated show up in the airport
            flightHour = thirtyMinLayout
              ? formatHourToNearest30Minutes(passengerDutTime)
              : String(new Date(passengerDutTime).getHours()).padStart(2, '0');
          }
        }
      } else if (flightType === 'departures' && preBoard && isALTPickUp && (iata === "JER" || iata === "SNN")) {
        const passengerDutTime = getPassengerDutTime(flightTime ? flightTime : flightDetails.departureTime, 2);
        if (passengerDutTime) {
          // passengerDutTime refers to the passenger estimated show up in the airport
          flightHour = thirtyMinLayout
            ? formatHourToNearest30Minutes(passengerDutTime)
            : String(new Date(passengerDutTime).getHours()).padStart(2, '0');
        }
      }

      // handle ALTPickUp specific flight naming
      if (isALTPickUp) {
        flight = iata === "JER" || iata === "SNN"
          ? flight
          : `${flight}/ALTPickUp`;
      }

      // check if booking is in timeline (if isALTPickUp it should have employeeId to be in the employee list jobs)
      const idKey = booking?.flightBooking && booking?.originalBookingId ? "originalBookingId" : "_id";

      const isInTimeline = isALTPickUp
        ? taskList.some((task) => task?._id === booking?._id && task?.employeeId)
        : taskList.some((task) => task?.[idKey] === booking?.[idKey] || task?.[idKey] === `${booking?.[idKey]}_IATA_${iata}`);

      // check for self allocated combined tasks
      const combinedField = flightType === 'departures' ? 'combinedBooking' : 'combinedRampBooking';
      // filter out the combinedBooking(boarding) and combinedRampBooking and self allocated tasks form task list 
      const selfAllocatedCombinedTasks = taskList.filter((task) => task?._id?.includes("-selfAllocatedTask-") && task?.[combinedField]);
      // array of self allocated passengers (not ramp or boarding)
      const selfAllocatedNotCombinedPax = taskList.filter((task) => task?._id?.includes("-selfAllocatedTask-") && !task?.[combinedField])?.flatMap(booking =>
        booking?.passengers?.map(passenger => passenger?.originalBookingId)
      );

      const groupedBookingTasks = taskList.filter((task) => task?.groupedBooking === true && task?.passengers?.length > 1 && !task?._id?.includes("-selfAllocatedTask-"))?.flatMap(booking =>
        booking?.passengers?.map(passenger => passenger?.originalBookingId)
      );



      //   // format list of buggy staff tasks(arrival task with multiple passengers)
      const arrivalsBuggyTaskList = Array.isFullArray(taskList)
        ? taskList?.filter((task) => task?.buggyTask === true && task?.flightBooking === true)
        : [];

      // format array of the originalBookingId of the passengers list in arrivalsBuggyTaskList
      const arrivalsBuggyBookingsIds = Array.isFullArray(arrivalsBuggyTaskList)
        ? arrivalsBuggyTaskList.flatMap(task => task?.passengers?.map(passenger => passenger?.originalBookingId))
        : [];

      // check if the booking is a self allocated and combinedBooking(boarding) or combinedRampBooking in task list don't show it in jobs list
      const isSelfAllocatedCombined = selfAllocatedCombinedTasks.some((task) => task?._id?.startsWith(`${booking?._id}-selfAllocatedTask-`));
      const isSelfAllocatedPassenger = selfAllocatedNotCombinedPax?.includes(booking?._id) || selfAllocatedNotCombinedPax?.includes(booking?.originalBookingId);
      const isArrivalBuggy = arrivalsBuggyBookingsIds?.includes(booking?.originalBookingId);
      const isGroupedBooking = groupedBookingTasks?.includes(booking?.originalBookingId ?? booking?._id);

      if ((isInTimeline || isSelfAllocatedPassenger || (isSelfAllocatedCombined && !isALTPickUp) || isArrivalBuggy || isGroupedBooking) && showAll !== true) return;

      // add to tempList
      const key = booking?.isALTPickUp && booking?.pickUpTime && iata !== "JER" && iata !== "SNN"
        ? `${flight}_${flightDetails.origin}_${flightDetails.destination}_pickupTime_${getJavaScriptDate(booking?.pickUpTime)?.toISOString()}_${booking?.pickUpLocation?.id}_${flightHour}`
        : `${flight}_${flightDetails.origin}_${flightDetails.destination}_${flightHour}`;

      if (!tempList[key]) {
        tempList[key] = [booking];
      } else {
        tempList[key].push(booking);
      }
    }
  });

  return tempList;
};

export const formatDuplicatedBoardings = (duplicatedBoardings, departuresBookings) => {
  return duplicatedBoardings.map(flightDoc => {
    // get flight details from the combined boarding
    const flightDetails = flightDoc?.doc?.flightConfirmationDetails;
    if (!flightDetails) return flightDoc;

    const carrierCode = flightDetails.carrierCode;
    const flightNumber = flightDetails.flightNumber;
    const flightKey = `${carrierCode}${flightNumber}`;

    // find all passengers in departureBookings that match this flight
    const matchingPassengers = departuresBookings
      .filter(booking => {
        const bookingFlightDetails = booking?.doc?.flightConfirmationDetails;
        if (!bookingFlightDetails) return false;

        const bookingCarrierCode = bookingFlightDetails.carrierCode;
        const bookingFlightNumber = bookingFlightDetails.flightNumber;
        const bookingFlightKey = `${bookingCarrierCode}${bookingFlightNumber}`;

        return bookingFlightKey === flightKey;
      })
      .map(booking => booking?.doc);

    // create a new booking document with updated passengers
    const updatedFlightDoc = {
      ...flightDoc,
      doc: {
        ...flightDoc?.doc,
        passengers: matchingPassengers ?? []
      }
    };

    return updatedFlightDoc;
  });
};



const formatPaxArray = (paxLocations, locationId) => {
  if (!Array.isFullArray(paxLocations)) return [];
  const locationPax = paxLocations?.filter((pax) => pax?.isALTPickUp ? pax?.paxPositionInfo?.locationId === locationId : pax?.locationId === locationId);

  if (!Array.isFullArray(locationPax)) return [];

  // Helper function to extract time value for sorting
  // Note: This function receives the original pax object before mapping
  const getTimeValue = (pax) => {
    if (pax?.isALTPickUp) {
      // For ALT pickups: use pickUpTime if exists, otherwise flightInformation?.flightTime
      if (pax?.pickUpTime?.seconds) {
        // Convert Firestore timestamp to milliseconds
        return pax.pickUpTime.seconds * 1000 + (pax.pickUpTime.nanoseconds || 0) / 1000000;
      }
      if (pax?.flightInformation?.flightTime) {
        return moment(pax.flightInformation.flightTime).valueOf();
      }
      return 0; // Fallback for items without time
    } else {
      // For regular passengers: use paxDoc?.paxPositionInfo?.time
      if (pax?.paxDoc?.paxPositionInfo?.time) {
        return moment(pax.paxDoc.paxPositionInfo.time).valueOf();
      }
      return 0; // Fallback for items without time
    }
  };

  // Sort by time first (oldest to newest), then map to the correct format
  const sortedPax = locationPax.sort((a, b) => {
    const timeA = getTimeValue(a);
    const timeB = getTimeValue(b);
    return timeA - timeB; // Sort from oldest to newest (ascending)
  });

  // Map to the correct format after sorting
  return sortedPax.map((pax) => pax?.isALTPickUp ? pax : pax?.paxDoc);
}
export const formatLiveLocations = (locationsList, paxLocations, showActivePaxLocations) => {
  if (!Array.isFullArray(locationsList)) return [];
  let tempLocations = locationsList.map((location) => {

    return {
      locationName: location?.title ?? "",
      locationId: location?._id ?? "",
      locationAreaId: location?.timelineId ?? "",
      paxArray: formatPaxArray(paxLocations, location?._id),
      color: location?.color ?? ""
    };
  });
  const sortedArray = tempLocations.sort((a, b) => {
    const aHasPax = a.paxArray && a.paxArray.length > 0;
    const bHasPax = b.paxArray && b.paxArray.length > 0;

    // sort objects with non-empty paxArray first
    if (aHasPax && !bHasPax) return -1;  // `a` comes first
    if (!aHasPax && bHasPax) return 1;   // `b` comes first
    return 0;  // keep original order if both have or don't have paxArray
  });

  return showActivePaxLocations ? sortedArray?.filter((location) => Array.isFullArray(location?.paxArray)) : sortedArray;

}

export const getImageCells = (cols, midSum = 1) => {
  let iColumnWidth = (cols.length * 6) / 12; // To convert column width in pixel unit.
  let mid = Math.floor(iColumnWidth / 2);
  let cell = mid + midSum;

  return {
    tl: { col: cell, row: 0 },
    vertical: "middle",
    horizontal: "center",
  };
};

export const nextLetter = (value) => {
  let carry = 1,
    res = "";
  for (let i = value.length - 1; i >= 0; i--) {
    let char = value.toUpperCase().charCodeAt(i);

    char += carry;

    if (char > 90) {
      char = 65;
      carry = 1;
    } else carry = 0;

    res = String.fromCharCode(char) + res;
    if (!carry) {
      res = value.substring(0, i) + res;
      break;
    }
  }

  if (carry) res = "A" + res;

  return res;
};

export function getDatesBetween(startDateStr, endDateStr) {
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  const dates = [];

  while (start <= end) {
    const isoDate = start.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    dates.push(isoDate);
    start.setDate(start.getDate() + 1);
  }

  return dates;
}

export const getHoursAndMinutes = (date) => {
  let jsDate;

  if (typeof date === 'string') {
    // handle string input (ISO format or other)
    jsDate = new Date(date);
  } else if (date && 'seconds' in date) {
    // handle Firestore Timestamp object
    jsDate = new Date(date.seconds * 1000 + Math.floor(date.nanoseconds / 1000000));
  } else if (date && '_seconds' in date) {
    jsDate = new Date(date._seconds * 1000 + Math.floor(date._nanoseconds / 1000000));

  } else if (date instanceof Date) {
    // handle existing Date object
    jsDate = date;
  } else {
    // default to current time
    jsDate = new Date();
  }

  const hour = jsDate.getHours();
  const minute = jsDate.getMinutes();

  // format as two-digit strings
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const getDurationTime = (startTime, completedTime) => {
  if (!startTime || !completedTime) return "Not completed";
  const seconds = startTime.seconds ?? startTime._seconds, nanoseconds = startTime.nanoseconds ?? startTime._nanoseconds;
  const startMillis = seconds * 1000 + nanoseconds / 1_000_000;
  const completedMillis = completedTime.seconds * 1000 + completedTime.nanoseconds / 1_000_000;

  const durationMs = completedMillis - startMillis;

  if (durationMs < 0) return "Invalid Time Range";

  const minutes = Math.ceil(durationMs / 60000);
  return `${minutes} min${minutes > 1 ? 's' : ''}`;
};

export const getReadableTimeString = (date) => {
  let jsDate;

  if (typeof date === 'string') {
    // handle string input (ISO format or other)
    jsDate = new Date(date);
  } else if (date && 'seconds' in date) {
    // handle Firestore Timestamp object
    jsDate = new Date(date.seconds * 1000 + Math.floor(date.nanoseconds / 1000000));
  } else if (date && '_seconds' in date) {
    jsDate = new Date(date._seconds * 1000 + Math.floor(date._nanoseconds / 1000000));

  } else if (date instanceof Date) {
    // handle existing Date object
    jsDate = date;
  } else {
    // default to current time
    jsDate = new Date();
  }

  // Return time without seconds (HH:MM format)
  return jsDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};


export const getJavaScriptDate = (date) => {
  let jsDate;

  if (typeof date === 'string') {
    // handle string input (ISO format or other)
    jsDate = new Date(date);
  } else if (date && 'seconds' in date) {
    // handle Firestore Timestamp object
    jsDate = new Date(date.seconds * 1000 + Math.floor(date.nanoseconds / 1000000));
  } else if (date && '_seconds' in date) {
    jsDate = new Date(date._seconds * 1000 + Math.floor(date._nanoseconds / 1000000));

  } else if (date instanceof Date) {
    // handle existing Date object
    jsDate = date;
  } else {
    // default to current time
    jsDate = new Date();
  }

  return jsDate;
};

export function extractTaskNotes(taskNotes) {
  if (!Array.isFullArray(taskNotes)) {
    return "Not Set";
  }

  let allComments = [];

  taskNotes.forEach(note => {
    if (note && note.userName && note.text) {
      allComments.push(`${note.userName}: ${note.text}`);
    }
  });

  return Array.isArray(allComments) && allComments?.length > 0 ? allComments.join(", ") : "Not Set";
}
export function extractFlightNotes(flightNotes) {
  if (typeof flightNotes === "string") return flightNotes;
  if (!Array.isFullArray(flightNotes)) {
    return "Not Set";
  }

  const parts = flightNotes
    .filter((note) => note && note.text != null)
    .map((note) => {
      const date = note.time ? new Date(note.time).toLocaleString() : "";
      return `${String(note.text)} added by ${String(note.userName ?? "")}${date ? ` at ${date}` : ""}`.trim();
    });

  return parts.length > 0 ? parts.join(", ") : "Not Set";
}

export const handleNotesText = (job, isFor) => {
  let noteText = "Not Set";
  const formatNoteEntries = (notes) => notes.map(note => {
    if (typeof note?.text !== 'string') return null;
    if (isFor === "tooltip") return note.text;

    const noteTime = note?.time ? `${getHoursAndMinutes(note.time)} - ` : "";
    const userName = note?.userName ? `${note.userName}: ` : "";
    return `${noteTime}${userName}${note.text}`;
  }).filter(Boolean).join(", \n");

  if (job?.taskNotes && Array.isFullArray(job?.taskNotes)) {
    noteText = formatNoteEntries(job.taskNotes);
  } else if (job?.taskNotes && typeof job?.taskNotes === 'string') {
    noteText = job?.taskNotes ?? "Not Set";
  } else if (job?.notes && Array.isFullArray(job?.notes)) {
    noteText = formatNoteEntries(job.notes);
  } else if (job?.notes && typeof job?.notes === 'string') noteText = job?.notes ?? "";
  else if (job?.originalBookingDoc?.notes && Array.isFullArray(job?.originalBookingDoc?.notes)) {
    noteText = formatNoteEntries(job.originalBookingDoc.notes);
  }
  else if (job?.originalBookingDoc?.notes && typeof job?.originalBookingDoc?.notes === 'string') noteText = job?.originalBookingDoc?.notes ?? "";
  else noteText = "Not Set";

  return typeof noteText === 'string' ? noteText : "Not Set"
};

export function extractNameFromBookingId(bookingId) {
  const namePart = bookingId.split("--")[1];
  const fullName = namePart.trim().split("_");
  const first = fullName[0] ?? "";
  const rest = fullName.slice(1).join(" ");

  const upper = first.toUpperCase();

  const knownSuffixes = [
    { suffix: "MRS", label: "Mrs" },
    { suffix: "MS", label: "Ms" },
    { suffix: "MR", label: "Mr" },
    { suffix: "MISS", label: "Miss" },
  ];

  for (const { suffix, label } of knownSuffixes) {
    if (upper.endsWith(suffix)) {
      const baseFirst = capitalize(first.slice(0, -suffix.length));
      const capitalizedRest = capitalizeWords(rest);

      return `${label} ${baseFirst} ${capitalizedRest}`.trim();

    }
  }

  // No known prefix found
  return `${capitalize(first)} ${capitalizeWords(rest)}`.trim();
}

export function getSurveyStatus(survey) {
  if (!survey) return "N/A";
  return survey.status === "completed" ? "Completed" : "Not Completed"
};

export const getJobPriority = (job) => {
  if (!Array.isArray(job?.doc?.assistance)) return Infinity;

  // find first matching assistance code
  for (let i = 0; i < ASSISTANCE_PRIORITY.length; i++) {
    if (job?.doc?.assistance?.some(a => a.includes(ASSISTANCE_PRIORITY[i]))) {
      return i; // lower index = higher priority
    }
  }
  return ASSISTANCE_PRIORITY.length; // goes after the prioritized ones
};

//Priorety:WCHC first, WCHS second, WCHR third, rest of assistances, no matter
export const sortJobsByAssistance = (jobs) => {
  return [...jobs].sort((a, b) => getJobPriority(a) - getJobPriority(b));
};

export const formatNameForAvatar = (name) => {
  if (!name || typeof name !== 'string') return '?';

  const trimmedName = name.trim();
  if (!trimmedName) return '?';

  const words = trimmedName.split(' ').filter(word => word.length > 0);

  if (words.length === 1) {
    // one word: take first character and capitalize
    return words[0].charAt(0).toUpperCase();
  } else if (words.length >= 2) {
    // more than one word: take first two words and capitalize first character of each
    const firstWord = words[0].charAt(0).toUpperCase();
    const secondWord = words[1].charAt(0).toUpperCase();
    return `${firstWord}${secondWord}`;
  }

  return '?';
};
export const hhmm = (isoDate, subtractBoardingMinutes = false) => {
  if (!isoDate) return "";
  const d = subtractBoardingMinutes ? new Date(new Date(isoDate).getTime() - 45 * 60 * 1000) : new Date(isoDate);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
};

export const setHHmm = (isoDate, hhmmStr) => {
  // falls back to today if isoDate is missing/bad
  const base = new Date(isoDate || Date.now());
  const [h, m] = (hhmmStr || "00:00").split(":").map((n) => parseInt(n, 10));
  base.setHours(h || 0, m || 0, 0, 0);
  return base.toISOString();
};


export const getPaxStatus = (pax, type, rejectReasons = []) => {

  if (!pax) return "Unknown";

  // Helper to get the reason label (converts MD5 hash to readable label if rejectReasons provided)
  const getReasonLabel = (reason) => {
    if (!reason) return "";
    if (!Array.isArray(rejectReasons) || rejectReasons.length === 0) return reason;
    return getRejectReasonLabel(rejectReasons, reason);
  };

  const isRejectedArrPax = pax?.originalBookingDoc
    ? pax?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalPax")
    : pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalPax");
  const isRejectedRampJourney = pax?.originalBookingDoc
    ? pax?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "rampJourney")
    : pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "rampJourney");
  const isRejectedArrivalJourney = pax?.originalBookingDoc
    ? pax?.originalBookingDoc?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalJourney")
    : pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalJourney");
  const isRejectedDepPax = pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "departurePax");
  const isRejectedBoardingJourney = pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "boardingJourney");
  const isRejectedPreBoardJourney = pax?.paxRejection?.find((paxRejection) => paxRejection?.type === "preBoardJourney");

  if (type === "preBoard") {

    // check for self assisted
    if (pax?.selfAssisted === true) {
      return "Self Assisted";
    }

    // Check for no show status first
    if (pax?.noShow === true) {
      return "No Show";
    }

    if (isRejectedPreBoardJourney) {
      return `Rejected Pre-Board, ${getReasonLabel(isRejectedPreBoardJourney?.reason) || ""}`;
    }
    if (isRejectedDepPax) {
      return `All Journey Rejected, ${getReasonLabel(isRejectedDepPax?.reason) || ""}`;
    }

    // check for pax task info
    if (pax?.tasks) {

      // Derive iata from booking when not present (API may not include it)
      const iata = pax?.iata ?? pax?.flightConfirmationDetails?.origin ?? pax?.tasks?.[0]?.flightInformation?.departureAirport;
      let preboardId = pax?._id + '_IATA_' + (iata ?? '');

      // use task to inform status
      let task = pax?.tasks?.find(t => t._id == preboardId);

      if (task) {

        // check if task is completed
        if (task?.completed === true) {
          return "Preboard Completed";
        }

        // check collected - pax was collected even if task completion not yet synced (before At Location, etc.)
        if (task?.active === true || pax?.selectDeparturePaxStatus === "collected") {
          return "Passenger Collected";
        }

        // check if task is at location
        if (task?.isAtLocation === true && task?.atLocationTime) {
          return "At Location";
        }

        // check if task is acknowledged
        if (task?.acknowledged === true && task?.acknowledgedTime) {
          return "Confirmed";
        }

        // check if task is allocated
        if (task?.employeeId || pax?.selectPreBoardPaxStatus === "selfAllocateSelected" || pax?.selectPreBoardPaxStatus === "selected") {
          return "Allocated";
        }
      }
    }

    // Check if passenger is checked in
    if (pax?.paxPositionInfo?.activity === "Checked-in") {
      return "Checked-in";
    }

    // check if job is completed
    const preboardCompleted = pax?.departureJourney?.some(j => j?.journey === "preBoard" && !!j?.completeTime);

    if (preboardCompleted) {
      return "Preboard Completed";
    }

    // check if job is active (employee has collected passenger)
    if (pax?.selectDeparturePaxStatus === "collected") {
      return "Passenger Collected";
    }

    // Check if passenger has not been presented at the airport
    if (!pax?.paxPositionInfo) {
      return "Not Presented";
    }

    // Check if employee was at location
    if (pax?.departureWaitingTime?.atLocationTime) {
      return "Agent at Location";
    }

    if (pax?.selectDeparturePaxStatus === "selfAllocateSelected" || pax?.selectDeparturePaxStatus === "selected") {
      return "Allocated";
    }
  }
  if (type === "ramp") {

    // check for rejection
    if (isRejectedRampJourney) {
      return `Rejected Ramp, ${getReasonLabel(isRejectedRampJourney?.reason) || ""}`;
    }

    if (isRejectedArrPax) {
      return `All Journey Rejected, ${getReasonLabel(isRejectedArrPax?.reason) || ""}`;
    }

    // log 
    //console.log('pax', pax, type);
    //console.log('pax?.rampTasks', pax?.rampTasks);

    if (pax?.rampTasks?.length > 0) {

      let status = 'Allocated';

      pax?.rampTasks?.forEach(rampTask => {

        // check if passenger is in list and is completed
        if (rampTask?.passengers && Array.isFullArray(rampTask?.passengers)) {
          // Use pax._id as fallback since booking objects don't have originalBookingId
          const bookingId = pax?.originalBookingId || pax?._id;
          let rampPax = rampTask?.passengers?.find(p => p?.originalBookingId === bookingId);
          if (rampPax) {
            // check if ramp status is completed
            if (rampPax?.selectPaxTime) {
              status = 'Passenger Collected'
            }
          }
        }

      });

      return status;

    }

    if (!pax.rampTasks && pax.originalBookingDoc?.selectRampPaxStatus === "collected") {
      return "Passenger Collected"
    }

    if (pax?.selectRampPaxStatus === "collected") {
      return "Collected";
    }
    if (pax.selectRampPaxStatus === "selfAllocateSelected" || pax.selectRampPaxStatus === "selected") {
      return "Selected";
    }
  }
  if (type === "boarding") {

    // check for rejection
    if (isRejectedBoardingJourney) {
      return `Rejected Boarding, ${getReasonLabel(isRejectedBoardingJourney?.reason) || ""}`;
    }
    if (isRejectedDepPax) {
      return `All Journey Rejected, ${getReasonLabel(isRejectedDepPax?.reason) || ""}`;
    }

    // check for boarding task (in tasks or boardingTasks - API may return either)
    const allTasks = [...(pax?.tasks || []), ...(pax?.boardingTasks || [])];
    let boardingTask = allTasks.find(t => t?._id?.includes("_BOARDING_"));

    if (boardingTask) {

      // check if passenger is part of passenger list
      if (boardingTask?.passengers && Array.isFullArray(boardingTask?.passengers)) {

        const bookingId = pax?.originalBookingId || pax?._id;
        let boardingPax = boardingTask?.passengers?.find(p => p?.originalBookingId === bookingId);

        if (boardingPax) {

          // check if boarding status is boarded (booking or passenger-in-task level)
          if (boardingPax?.selectBoardingPaxStatus === "boarded" || pax?.selectBoardingPaxStatus === "boarded") {
            return "Boarding Completed";
          }

          // check if boarding has started (employee has picked up passenger)
          if (boardingTask?.active === true || (boardingTask?.boardingStarted === true && boardingTask?.boardingStartTime)) {
            return "Boarding Started";
          }

          // check if employee is at location
          if (boardingTask?.isAtLocation === true && boardingTask?.atLocationTime) {
            return "At Location";
          }

          // check if task has been acknowledged by employee
          if (boardingTask?.acknowledged === true && boardingTask?.acknowledgedTime) {
            return "Confirmed";
          }

          // check if boarding status is allocated
          if (boardingPax?.selectBoardingPaxStatus === "selfAllocateSelected" || boardingPax?.selectBoardingPaxStatus === "selected") {
            return "Allocated";
          }

        }
      }
    }

    // Check for no show status first
    if (pax?.noShow === true) {
      return "No Show";
    }
    // else if (isRejectedBoardingJourney) {
    //   return `Rejected Boarding, ${getReasonLabel(isRejectedBoardingJourney?.reason) || ""}`;
    // }
    // if (isRejectedDepPax) {
    //   return `All Journey Rejected, ${getReasonLabel(isRejectedDepPax?.reason) || ""}`;
    // }
    else if (pax?.selectBoardingPaxStatus === "boarded") {
      return "Boarding Completed";
    }
    else if (pax?.boardingAssistNeeded == false) {
      return "No Boarding Assistance Required";
    }
    // Only show Allocated when boarding task exists (avoids stale status when unplanned)
    else if (boardingTask && (pax?.selectBoardingPaxStatus === "selfAllocateSelected" || pax?.selectBoardingPaxStatus === "selected")) {
      return "Allocated";
    }
    // check if pax is presented as a preboard
    if (pax?.paxPositionInfo?.activity === "Checked-in" || pax?.paxPositionInfo?.activity === "assigned") {

      // pax has requested service - waiting for preboard (not completed) or boarding (preboard completed)
      return "Waiting for Service";
    }
    else if (!pax?.paxPositionInfo) {
      return "Not Presented";
    }
  }
  if (type === "arrival") {

    // Check for rejection
    if (isRejectedArrivalJourney) {
      return `Rejected Arrival, ${getReasonLabel(isRejectedArrivalJourney?.reason) || ""}`;
    }

    if (isRejectedArrPax) {
      return `All Journey Rejected, ${getReasonLabel(isRejectedArrPax?.reason) || ""}`;
    }

    // check for tasks
    if (pax?.tasks) {
      // try find arrival journey task
      // Use originalBookingId if available, otherwise fall back to _id (for raw bookings)
      let arrivalJourneyId = pax?.originalBookingId || pax?._id;

      let arrivalJourneyTask = pax?.tasks?.find(t => t?.originalBookingId == arrivalJourneyId && t?.completeWithNoSelection !== true);

      if (arrivalJourneyTask) {

        // check if task is completed
        if (arrivalJourneyTask?.completed === true) {
          return "Arrival Completed";
        }

        // check if task is active
        if (arrivalJourneyTask?.active === true) {
          return "Active";
        }

        // check if task is at location
        if (arrivalJourneyTask?.isAtLocation === true && arrivalJourneyTask?.atLocationTime) {
          return "At Location";
        }

        // check if task is acknowledged
        if (arrivalJourneyTask?.acknowledged === true && arrivalJourneyTask?.acknowledgedTime) {
          return "Confirmed";
        }

        // check allocated
        if (arrivalJourneyTask?.allocatedTime) {
          return "Allocated";
        }

        // check if task is allocated
        if (arrivalJourneyTask?.employeeId || pax?.selectArrivalPaxStatus === "selfAllocateSelected" || pax?.selectArrivalPaxStatus === "selected") {
          return "Allocated";
        }
      }
    }

    // check for original booking doc
    // if (pax?.originalBookingDoc) {
    // check for self assisted
    if (pax?.originalBookingDoc?.selfAssisted === true || pax?.selfAssisted === true) {
      return "Self Assisted";
    }

    // Check for no show status first
    if (pax?.originalBookingDoc?.noShow === true || pax?.noShow === true) {
      return "No Show";
    }

    // check if cancelled
    if (pax?.originalBookingDoc?.cancelled === true || pax?.cancelled === true) {
      return "Cancelled";
    }

    // check if completed
    if (pax?.originalBookingDoc?.completed === true || pax?.completed === true) {
      return "Completed";
    }

    // check if checked in
    if (pax?.originalBookingDoc?.arrivalPaxCheckIn?.locationId || pax?.arrivalPaxCheckIn?.locationId) {
      return "Checked-in";
    }

    // }



    // Check if cancelled
    if (pax?.cancelled === true) {
      return "Cancelled";
    }

    // Check if task is completed (for tasks with completed flag)
    if (pax?.completed === true || pax?.paxPositionInfo?.activity === "Dropped Off") {
      return "Completed";
    }

    // Check if task is active (for tasks with active flag)
    if (pax?.active === true) {
      return "Active";
    }

    // Check if employee is at location
    if (pax?.isAtLocation === true && pax?.atLocationTime) {
      return "At Location";
    }

    // Check for booking status collected
    if (pax?.selectArrivalPaxStatus === "collected") {
      return "Collected";
    }

    // Check if task has been acknowledged (allocated and acknowledged)
    if (pax?.acknowledged === true && pax?.acknowledgedTime) {
      return "Confirmed";
    }

    // Check if allocated (task has employeeId or booking is selected)
    if (pax?.employeeId || pax?.selectArrivalPaxStatus === "selfAllocateSelected" || pax?.selectArrivalPaxStatus === "selected") {
      return "Allocated";
    }

    // Check if task has been created (has allocatedTime)
    if (pax?.allocatedTime) {
      return "Pending";
    }
  }

  return "Waiting for Service";
};


export function normalizeErrors(e) {
  if (!e) return {};
  if (Array.isArray(e)) {

    const obj = {};
    e.forEach(item => {
      if (item && item.field && item.message) obj[item.field] = item.message;
    });
    return obj;
  }
  // already an object like { firstName: '...' }
  return typeof e === 'object' ? e : {};
}

export function isPreAdvisedTask(task) {
  if (!task || !task.flightInformation || !task.flightInformation.flightTime) return false;

  const flightTime = moment(new Date(task.flightInformation.flightTime));

  // single date or array (preserve alignment; don't filter out falsy)
  let dates = task.bookingCreateDate;
  if (!dates && Array.isArray(task.passengers)) {
    dates = task.passengers.map(p => p && p.bookingCreateDate);
  }
  if (dates == null) return false;

  const toBool = (d) => {
    const dt = new Date(d);
    if (isNaN(dt)) return false;
    return flightTime.diff(dt, 'hours', true) > 36;
  };

  return Array.isArray(dates) ? dates.map(toBool) : toBool(dates);
}
const yesNo = (b) => (b ? "Yes" : "No");

export function formatPreadvised(val, joinWith = ', ') {
  return Array.isArray(val) ? val.map(yesNo).join(joinWith) : yesNo(val);
}


export function isDepartureOrArrivalTask(document, iata) {
  return document?.flightInformation?.arrivalAirport === iata ? "A" : "D"
}

function toDate(input) {
  if (!input) return null;
  if (typeof input === "object" && typeof input.seconds === "number") {
    return new Date(input.seconds * 1000);
  }
  const d = input instanceof Date ? input : new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

// Format as: 2025-09-17 12:36 AM
export function formatDayTime(input, { utc = false } = {}) {
  const d = toDate(input);
  if (!d) return "N/A";
  const m = utc ? moment(d).utc() : moment(d);
  return m.format("YYYY-MM-DD hh:mm A");
}

export function isNormalTask(task) {

  return !task.combinedRampBooking && !task.combinedBooking && !task.groupedBooking && !task.flightTask && !task?.flightBooking
}


export const newProcessName = (
  name,
  options = {}
) => {
  // Default options
  const {
    removeTitle = false,
    truncateTo,
    capitalize = true,
  } = options;

  // Handle invalid inputs
  if (typeof name !== "string") return "";
  if (name === "Passenger No. 1" || name === "n/a") return name;

  // Helper function for capitalization
  const capitalizeString = (str) => {
    if (!capitalize || !str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Process titles in the name
  let processedName = name.trim();

  // Handle special title cases (MR, MRS, MS, MISS at end of first name)
  const parts = processedName.split(/\s+/);
  if (parts.length >= 2) {
    const first = parts[0];
    const rest = parts.slice(1).join(" ");

    const titleMap = {
      'MRS$': 'Mrs',
      'MS$': 'Ms',
      'MR$': 'Mr',
      'MISS$': 'Miss'
    };

    for (const pattern in titleMap) {
      const replacement = titleMap[pattern];
      if (new RegExp(pattern).test(first)) {
        const cleanFirst = first.replace(new RegExp(pattern), '');
        processedName = `${replacement} ${capitalizeString(cleanFirst)} ${capitalizeString(rest)}`;
        break;
      }
    }
  }

  // Remove standard titles if requested
  if (removeTitle) {
    processedName = processedName.replace(/^(Mr|Mrs|Ms|Dr|Prof|Miss)\.?\s+/i, '');
  }

  // Capitalize all words if requested and no special formatting was applied
  if (capitalize && processedName === name) {
    processedName = processedName.split(/\s+/)
      .map(word => capitalizeString(word))
      .join(' ');
  }

  // Truncate if requested
  if (truncateTo && truncateTo > 0 && processedName.length > truncateTo) {
    processedName = processedName.substring(0, truncateTo) + '...';
  }

  return processedName.trim();
};

export const eqUnorderedStringArrays = (a, b) => {
  if (a.length !== b.length) return false;
  const sortedFirstArray = [...a].sort();
  const sortedSecondArray = [...b].sort();
  return sortedFirstArray.every((v, i) => v === sortedSecondArray[i]);
};

export const getOriginalBooking = (bookingsArray, id) => {
  if (!Array.isArray(bookingsArray) || !id) return {};
  const booking = Array.isArray(bookingsArray)
    ? bookingsArray.find(b => b._id === id || b.id === id) || {}
    : {};
  return booking
}

export const formatJourneyName = (journeyName) => {

  if (journeyName?.includes("transferred")) {
    return `Transferred ${journeyName?.split("_")[1]}`;
  }
  switch (journeyName) {
    case "boarding":
      return "Boarding";

    case "preBoard":
      return "Pre-Board";


    case "isALTPickUp":
      return "ALT Pick Up";

    case "ramp":
      return "Ramp";

    case "arrival":
      return "Arrival";

    case "rejected":
      return "Rejected";

    case "boarding (rejected)":
      return "Boarding (Rejected)";

    default:
      return journeyName || "N/A";
  }
};

export const formatCarrierCodeAndFlightNumber = (flightNumber) => {
  const match = flightNumber?.match(/^([A-Z]{2,3})(\d+[A-Z]?)$/i) ?? "";
  let carrierCode = match?.[1]?.toUpperCase() ?? flightNumber?.substring(0, 2);
  const number = match?.[2] ?? flightNumber?.substring(2);
  if (carrierCode == 'EZY' || carrierCode == 'EJU') {
    carrierCode = 'U2'
  }
  return {
    carrierCode,
    number
  }
};

// create an arrival doc
export function createArrivalDoc(booking, iata, flightList) {
  // check booking exists
  if (!booking) return null;

  // get flight number
  const flightNumber = booking.flightConfirmationDetails?.carrierCode + booking.flightConfirmationDetails?.flightNumber;

  // get flight time from booking doc
  let tempArrivalTime = booking.flightConfirmationDetails?.arrivalTime || booking.flightConfirmationDetails?.departureTime || new Date();

  /* try get time of flight from flight doc if available TO DO!!! */

  // get flight hour
  const flightHour = String(new Date(tempArrivalTime).getHours()).padStart(2, "0");

  // create index for passenger using flight list count
  let index = 1;                                                // initalize index as 1 

  // check if other passengers have already been added to the list
  if (flightList && flightList.length > 0) {
    index = flightList.length + 1;                             // set index to length + 1
  }

  // check if booking is a duplicate (has -partX in id)  
  const matchDuplicateID = booking._id?.match(/-part(\d+)$/);

  // create unique id for arrival booking (even if it has duplicates)
  let newId = '';

  if (booking._id?.includes("-part")) {
    newId = `${flightNumber}-${index}-${tempArrivalTime?.split("T")[0]}-${matchDuplicateID?.[0] ?? ""}`;
  }
  else {
    newId = `${flightNumber}-${index}-${tempArrivalTime?.split("T")[0]}`;
  }

  return {
    _id: newId,
    flightConfirmationDetails: {
      ...booking.flightConfirmationDetails,
      arrivalTime: tempArrivalTime,
    },
    isTransitBooking: booking.isTransitBooking,
    // name: "Pax " + index,
    name: iata === "JER" ? booking.name : "Pax " + index,
    flightBooking: true,
    originalBookingId: booking._id,
    assistance: booking.assistance ?? [],
    originalBookingDoc: {
      ...booking,
      flightConfirmationDetails: {
        ...booking.flightConfirmationDetails,
        arrivalTime:
          booking.flightConfirmationDetails?.arrivalTime ||
          tempArrivalTime,
      },
    },
  };

}

export const getRejectReasonLabel = (reasons, value) => {
  if (!Array.isArray(reasons) || typeof value !== "string") return "N/A"
  // regex for 32-character lowercase hex MD5
  const isMd5Hash = /^[a-f0-9]{32}$/i.test(value);

  if (!isMd5Hash) return value; // plain text, show it directly

  // find matching label by hashed value
  const found = reasons.find(r => r.value === value);
  return found?.label || "N/A";
}
//This function will check if document is task or booking, then get type of document
//It returns an object with isTask:true/false and jobType,departue, arrival.altpick,ramp,boarding....
//Please check rest of types like grouped/flight task
export function checkBookingOrTaskProperties(doc, iata) {

  const result = {
    isTask: false,
    jobType: "departure"
  };
  if (!doc) return result;

  let jobType = "departure";

  if (doc?.isALTPickUp) {
    result.isTask = true;
    result.jobType = "alt-pickup";
    return result;
  }


  if (doc?.isBreakTask) {
    result.isTask = true;
    result.jobType = "break-task";
    return result;
  }

  // Check if it's a task (has employee assigned)
  if (doc?.employeeId) {
    result.isTask = true;
    if (doc?.combinedBooking) jobType = "boarding";
    else if (doc?.combinedRampBooking) jobType = "ramp-task";
    else if (doc?.flightbooking || doc?.flightBooking) jobType = "arrival";
    else {
      // Use flightInformation to determine arrival vs departure when available
      const dep = doc?.flightInformation?.departureAirport;
      const arr = doc?.flightInformation?.arrivalAirport;
      if (iata && arr === iata) jobType = "arrival";
      else if (iata && dep === iata) jobType = "departure";
      else jobType = "departure"; // fallback
    }
    result.jobType = jobType;
  } else {
    result.isTask = false;
    if (doc?.isBoardingBooking) jobType = "boarding";
    else if (doc?.combinedRampBooking) jobType = "ramp-task";
    else if (doc?.flightConfirmationDetails) {
      jobType = doc.flightConfirmationDetails.origin === iata ? "departure" : "arrival";
    }
    result.jobType = jobType;
  }

  return result;
}

/**
 * Derive a flight document id from a task/job object.
 * Attempts existing ids first, then constructs one from available flight data.
 */
export function deriveFlightIdFromTask(task, userIata = "") {
  if (!task) return null;

  // prefer any existing id/key provided
  const directId =
    task?.flightId ||
    task?.flightKey ||
    task?.flightData?.flightId;

  let flightId = directId || null;

  // construct from task flight information (tasks)
  if (!flightId && task?.flightInformation) {
    const info = task.flightInformation;
    const date =
      info?.flightDate ||
      info?.departureDate ||
      info?.arrivalDate ||
      "";

    // match existing usage: append the relevant airport at the end
    const tailAirport = userIata || info?.departureAirport || info?.arrivalAirport || "";

    if (info?.flightNumber && info?.departureAirport && info?.arrivalAirport) {
      flightId = `${info.flightNumber}_${info.departureAirport}_${info.arrivalAirport}_${date}`;
      if (tailAirport) {
        flightId = `${flightId}_IATA_${tailAirport}`
      };
    }
  }

  // construct from booking confirmation details (jobs/bookings)
  if (!flightId && task?.flightConfirmationDetails) {
    const conf = task.flightConfirmationDetails;
    const date = conf?.departureDate || "";
    const tailAirport = userIata || conf?.origin || "";
    if (
      conf?.flightNumber &&
      conf?.carrierCode &&
      conf?.origin &&
      conf?.destination
    ) {
      flightId = `${conf.carrierCode}${conf.flightNumber}_${conf.origin}_${conf.destination}_${date}`;
      if (tailAirport) {
        flightId = `${flightId}_IATA_${tailAirport}`
      };
    }
  }

  // append boarding suffix when applicable
  if (flightId && (task?.isBoardingBooking || task?._id?.includes("BOARDING"))) {
    flightId = `${flightId}_BOARDING`;

  }

  return flightId;
}
//it will return 1hour/30 min slot, suppose I pass 10:45 time, it will return 10:30-11:00 (30 slot), or 10:00-11:00
export function getSlotOfTime(assignTime, slot = "30") {
  if (!assignTime) return "--:--";
  const amOrPm = assignTime.slice(assignTime.length - 2, assignTime.length)
  const [hh, mm] = assignTime.split(":").map(Number);

  let startMin, endMin;

  if (slot === "30") {
    // 30 MIN SLOT
    // Round down to nearest 30 min
    startMin = mm < 30 ? 0 : 30;

    // End time
    endMin = startMin + 30;
  } else {
    // 60 MIN SLOT (1 hour)
    startMin = 0;
    endMin = 60;
  }

  const startHour = hh;
  const endHour = hh + Math.floor(endMin / 60);

  const start = `${String(startHour).padStart(2, "0")}:${String(startMin % 60).padStart(2, "0")}`;
  const end = `${String(endHour).padStart(2, "0")}:${String(endMin % 60).padStart(2, "0")}`;

  return `${start}-${end} ${amOrPm}`;
}

// returns the minute rounded down to the nearest 5-minute mark (0-55)
export function getFiveMinuteIntervalMinute(time) {
  if (!time) return 0;
  const d = new Date(time);
  if (Number.isNaN(d.getTime())) return 0;
  const minutes = d.getMinutes();
  return Math.floor(minutes / 5) * 5;
}

export function addFiveMinuteOffset(time, index) {
  // time: "HH:MM"
  // index: integer (0 → no change, 1 → +5 min, 2 → +10 min, ...)
  const [hours, minutes] = time.split(":").map(Number);
  const totalMinutes = minutes + index * 5;

  const date = new Date();
  date.setHours(hours, totalMinutes, 0, 0);

  // Format back to HH:MM
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}`;
}

export const addTwoHours = (timeStr) => {
  if (timeStr === null || timeStr === undefined) return timeStr;
  if (timeStr === "") return "";

  const [h, m] = timeStr?.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  d.setHours(d.getHours() + 2);
  return d.toTimeString().slice(0, 5); // "HH:MM"
};

export const roundDownToHour = (timeStr) => {
  const [h] = timeStr?.split(":").map(Number);
  return `${String(h).padStart(2, "0")}:00`;
};


export const getIataTimezone = (iata) => {
  if (SaudiDomesticAirports.includes(iata)) return 'Asia/Riyadh';
  if (iata === 'PUJ') return 'America/Santo_Domingo';
  return 'Europe/Dublin';
};

const getNormalizedAppVersion = (appVersionNumber) => {
  if (!appVersionNumber || typeof appVersionNumber !== "string") return null;

  const versionMatch = appVersionNumber.match(/\d+\.\d+\.\d+/);
  return versionMatch ? versionMatch[0] : null;
};

export function checkAppVersion(appVersionNumber, minimumVersion = "1.1.6", includeMinimumVersion = false) {
  const appVersion = getNormalizedAppVersion(appVersionNumber);
  const minVersion = getNormalizedAppVersion(minimumVersion);

  if (!appVersion || !minVersion) return false;

  const appParts = appVersion.split(".").map(Number);
  const minParts = minVersion.split(".").map(Number);

  for (let i = 0; i < minParts.length; i += 1) {
    const appPart = appParts[i] ?? 0;
    const minPart = minParts[i] ?? 0;

    if (appPart > minPart) return true;
    if (appPart < minPart) return false;
  }

  return includeMinimumVersion;
}

export function getEmployeeStatusForAppVersion(status, appVersionNumber) {
  if (checkAppVersion(appVersionNumber)) return status;
  if (status === "online" || status === "offline") return status;
  return null;
}
